/* tslint:disable */
/* eslint-disable */
/**
 * Radianse Element API - .Net 6
 * <b>Build:</b>Radianse.App.Elements_main_2023.9.5.1
 *
 * The version of the OpenAPI document: UserApi_V1
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @enum {string}
 */

export const IAddressType = {
  Unknown: "Unknown",
  Home: "Home",
  Work: "Work",
  Other: "Other",
} as const;

export type IAddressType = typeof IAddressType[keyof typeof IAddressType];

/**
 *
 * @export
 * @enum {string}
 */

export const IClientTreeType = {
  Customer: "Customer",
  Tenant: "Tenant",
  Group: "Group",
} as const;

export type IClientTreeType =
  typeof IClientTreeType[keyof typeof IClientTreeType];

/**
 *
 * @export
 * @interface IConnector
 */
export interface IConnector {
  /**
   *
   * @type {string}
   * @memberof IConnector
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof IConnector
   */
  partitionKey?: string;
  /**
   *
   * @type {string}
   * @memberof IConnector
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IConnector
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IConnector
   */
  name: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IConnector
   */
  options?: { [key: string]: any };
  /**
   *
   * @type {boolean}
   * @memberof IConnector
   */
  deleted?: boolean | null;
}
/**
 * Connector
 * @export
 * @interface IConnectorDto
 */
export interface IConnectorDto {
  /**
   * Name
   * @type {string}
   * @memberof IConnectorDto
   */
  name: string;
  /**
   * List of options the UI might need when working with the Connector.
   * @type {{ [key: string]: any; }}
   * @memberof IConnectorDto
   */
  options?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface IConnectorIRadianseResult
 */
export interface IConnectorIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IConnectorIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IConnector}
   * @memberof IConnectorIRadianseResult
   */
  data?: IConnector;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IConnectorIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IConnectorIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IConnectorIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IConnectorIRadianseResultSuccess
 */
export interface IConnectorIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IConnectorIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IConnector}
   * @memberof IConnectorIRadianseResultSuccess
   */
  data: IConnector;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IConnectorIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IConnectorIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IConnectorIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IConnectorInfo
 */
export interface IConnectorInfo {
  /**
   *
   * @type {string}
   * @memberof IConnectorInfo
   */
  id?: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IConnectorInfo
   */
  options?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface IConnectorListIRadianseResult
 */
export interface IConnectorListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IConnectorListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IConnector>}
   * @memberof IConnectorListIRadianseResult
   */
  data?: Array<IConnector> | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IConnectorListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IConnectorListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IConnectorListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IConnectorListIRadianseResultSuccess
 */
export interface IConnectorListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IConnector>}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  data: Array<IConnector>;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IConnectorListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IContactDto
 */
export interface IContactDto {
  /**
   * Title
   * @type {string}
   * @memberof IContactDto
   */
  salutation: string;
  /**
   * Name
   * @type {string}
   * @memberof IContactDto
   */
  firstName: string;
  /**
   * Name
   * @type {string}
   * @memberof IContactDto
   */
  lastName: string;
  /**
   * Phone number
   * @type {string}
   * @memberof IContactDto
   */
  phoneNumber: string;
  /**
   * Email
   * @type {string}
   * @memberof IContactDto
   */
  email: string;
}
/**
 * Media data in format of DataUrl
 * @export
 * @interface IDataUrlDto
 */
export interface IDataUrlDto {
  /**
   * Base 64 encode data
   * @type {string}
   * @memberof IDataUrlDto
   */
  data: string;
}
/**
 *
 * @export
 * @interface IDocumentTemplateRequirements
 */
export interface IDocumentTemplateRequirements {
  /**
   *
   * @type {string}
   * @memberof IDocumentTemplateRequirements
   */
  documentId?: string;
  /**
   *
   * @type {Array<IHandlebarsType>}
   * @memberof IDocumentTemplateRequirements
   */
  requiredData?: Array<IHandlebarsType>;
}
/**
 *
 * @export
 * @interface IDocumentWeighted
 */
export interface IDocumentWeighted {
  /**
   *
   * @type {string}
   * @memberof IDocumentWeighted
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentWeighted
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentWeighted
   */
  description?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentWeighted
   */
  weightedValue?: number;
}
/**
 *
 * @export
 * @interface IDocumentWeightedRule
 */
export interface IDocumentWeightedRule {
  /**
   *
   * @type {string}
   * @memberof IDocumentWeightedRule
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof IDocumentWeightedRule
   */
  weightedTotalValue?: number;
  /**
   *
   * @type {Array<IDocumentWeighted>}
   * @memberof IDocumentWeightedRule
   */
  documents?: Array<IDocumentWeighted>;
}
/**
 *
 * @export
 * @interface IElementNote
 */
export interface IElementNote {
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  partitionKey?: string;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  tenantId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  elementId: string;
  /**
   *
   * @type {IElementNoteType}
   * @memberof IElementNote
   */
  noteType?: IElementNoteType;
  /**
   *
   * @type {IElementNoteStatusType}
   * @memberof IElementNote
   */
  statusType?: IElementNoteStatusType;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  note: string;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  identityProfileId: string;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  identityProfileName: string;
  /**
   *
   * @type {string}
   * @memberof IElementNote
   */
  timeStamp: string;
}
/**
 * Note partitioned by the element id
 * @export
 * @interface IElementNoteDto
 */
export interface IElementNoteDto {
  /**
   *
   * @type {IElementNoteType}
   * @memberof IElementNoteDto
   */
  noteType?: IElementNoteType;
  /**
   * Notes
   * @type {string}
   * @memberof IElementNoteDto
   */
  note: string;
  /**
   * IdentityProfileId. Defaults to authenticated caller.
   * @type {string}
   * @memberof IElementNoteDto
   */
  identityProfileId?: string | null;
  /**
   * Identity profile name. Defaults to authenticated caller.
   * @type {string}
   * @memberof IElementNoteDto
   */
  identityProfileName?: string | null;
  /**
   * The time the note was added. Defaults to current UTC time
   * @type {string}
   * @memberof IElementNoteDto
   */
  timeStamp?: string | null;
}
/**
 *
 * @export
 * @interface IElementNoteListIRadianseResult
 */
export interface IElementNoteListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IElementNoteListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IElementNote>}
   * @memberof IElementNoteListIRadianseResult
   */
  data?: Array<IElementNote> | null;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IElementNoteListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IElementNoteListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IElementNoteListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IElementNoteListIRadianseResultSuccess
 */
export interface IElementNoteListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IElementNote>}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  data: Array<IElementNote>;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementNoteListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IElementNoteStatusType = {
  Active: "Active",
  Maintenance: "Maintenance",
} as const;

export type IElementNoteStatusType =
  typeof IElementNoteStatusType[keyof typeof IElementNoteStatusType];

/**
 *
 * @export
 * @enum {string}
 */

export const IElementNoteType = {
  Maintenance: "Maintenance",
} as const;

export type IElementNoteType =
  typeof IElementNoteType[keyof typeof IElementNoteType];

/**
 *
 * @export
 * @interface IElementTree
 */
export interface IElementTree {
  /**
   *
   * @type {string}
   * @memberof IElementTree
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTree
   */
  parentId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTree
   */
  name: string;
}
/**
 * Child in the element tree
 * @export
 * @interface IElementTreeChildDto
 */
export interface IElementTreeChildDto {
  /**
   * Parent ID
   * @type {string}
   * @memberof IElementTreeChildDto
   */
  parentId: string;
  /**
   * Name
   * @type {string}
   * @memberof IElementTreeChildDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface IElementTreeIRadianseResult
 */
export interface IElementTreeIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IElementTreeIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IElementTree}
   * @memberof IElementTreeIRadianseResult
   */
  data?: IElementTree;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IElementTreeIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IElementTreeIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IElementTreeIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IElementTreeIRadianseResultSuccess
 */
export interface IElementTreeIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IElementTree}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  data: IElementTree;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IElementTreeListIRadianseResult
 */
export interface IElementTreeListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IElementTreeListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IElementTree>}
   * @memberof IElementTreeListIRadianseResult
   */
  data?: Array<IElementTree> | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IElementTreeListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IElementTreeListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IElementTreeListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IElementTreeListIRadianseResultSuccess
 */
export interface IElementTreeListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IElementTree>}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  data: Array<IElementTree>;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IElementTreeTreeItem
 */
export interface IElementTreeTreeItem {
  /**
   *
   * @type {IElementTree}
   * @memberof IElementTreeTreeItem
   */
  item?: IElementTree;
  /**
   *
   * @type {Array<IElementTreeTreeItem>}
   * @memberof IElementTreeTreeItem
   */
  children?: Array<IElementTreeTreeItem>;
}
/**
 *
 * @export
 * @interface IElementTreeTreeItemIEnumerableIRadianseResult
 */
export interface IElementTreeTreeItemIEnumerableIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IElementTreeTreeItem>}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  data?: Array<IElementTreeTreeItem> | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IElementTreeTreeItemIEnumerableIRadianseResultSuccess
 */
export interface IElementTreeTreeItemIEnumerableIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IElementTreeTreeItem>}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  data: Array<IElementTreeTreeItem>;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IElementTreeTreeItemIEnumerableIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEquipment
 */
export interface IEquipment {
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  subCategory?: string;
  /**
   *
   * @type {boolean}
   * @memberof IEquipment
   */
  deleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  eventsId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  manufacturer: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IEquipment
   */
  elementTree?: Array<string> | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IEquipment
   */
  activationConfiguration?: { [key: string]: any } | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IEquipment
   */
  configuration?: { [key: string]: any } | null;
  /**
   *
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IEquipment
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  model: string;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  name: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof IEquipment
   */
  requirementTypeIds?: { [key: string]: string } | null;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  serialNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  category?: string;
  /**
   *
   * @type {Array<IConnectorInfo>}
   * @memberof IEquipment
   */
  connectors?: Array<IConnectorInfo>;
  /**
   *
   * @type {IEquipmentStatusType}
   * @memberof IEquipment
   */
  status?: IEquipmentStatusType;
  /**
   *
   * @type {string}
   * @memberof IEquipment
   */
  search?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IEquipment
   */
  searchW?: Array<string> | null;
}
/**
 * Equipment
 * @export
 * @interface IEquipmentDto
 */
export interface IEquipmentDto {
  /**
   * Deleted
   * @type {boolean}
   * @memberof IEquipmentDto
   */
  deleted?: boolean;
  /**
   * EventsId
   * @type {string}
   * @memberof IEquipmentDto
   */
  eventsId?: string | null;
  /**
   * Manufacturer
   * @type {string}
   * @memberof IEquipmentDto
   */
  manufacturer: string;
  /**
   * Element tree
   * @type {Array<string>}
   * @memberof IEquipmentDto
   */
  elementTree?: Array<string> | null;
  /**
   * Activation configuration
   * @type {{ [key: string]: any; }}
   * @memberof IEquipmentDto
   */
  activationConfiguration?: { [key: string]: any } | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IEquipmentDto
   */
  configuration?: { [key: string]: any } | null;
  /**
   * Customer specific information for display purposes. Business logic should not be done.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IEquipmentDto
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
  /**
   * Model
   * @type {string}
   * @memberof IEquipmentDto
   */
  model: string;
  /**
   * Name
   * @type {string}
   * @memberof IEquipmentDto
   */
  name: string;
  /**
   * Rule requirements. The event must pass the rules defined by this requirement type before being allowed to enter the stage
   * @type {{ [key: string]: string; }}
   * @memberof IEquipmentDto
   */
  requirementTypeIds?: { [key: string]: string } | null;
  /**
   * Serial number
   * @type {string}
   * @memberof IEquipmentDto
   */
  serialNumber?: string | null;
  /**
   * Connector information.
   * @type {Array<IConnectorInfo>}
   * @memberof IEquipmentDto
   */
  connectors?: Array<IConnectorInfo>;
}
/**
 * Equipment class for patch operation
 * @export
 * @interface IEquipmentPatchDto
 */
export interface IEquipmentPatchDto {
  /**
   * EventsId
   * @type {string}
   * @memberof IEquipmentPatchDto
   */
  eventsId?: string | null;
  /**
   * Manufacturer
   * @type {string}
   * @memberof IEquipmentPatchDto
   */
  manufacturer?: string | null;
  /**
   * Activation configuration
   * @type {{ [key: string]: any; }}
   * @memberof IEquipmentPatchDto
   */
  activationConfiguration?: { [key: string]: any } | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IEquipmentPatchDto
   */
  configuration?: { [key: string]: any } | null;
  /**
   * Customer specific information for display purposes. Business logic should not be done.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IEquipmentPatchDto
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
  /**
   * Model
   * @type {string}
   * @memberof IEquipmentPatchDto
   */
  model?: string | null;
  /**
   * Name
   * @type {string}
   * @memberof IEquipmentPatchDto
   */
  name?: string | null;
  /**
   * Rule requirements. The event must pass the rules defined by this requirement type before being allowed to enter the stage
   * @type {{ [key: string]: string; }}
   * @memberof IEquipmentPatchDto
   */
  requirementTypeIds?: { [key: string]: string } | null;
  /**
   * Serial number
   * @type {string}
   * @memberof IEquipmentPatchDto
   */
  serialNumber?: string | null;
  /**
   * Connector ID
   * @type {Array<IConnectorInfo>}
   * @memberof IEquipmentPatchDto
   */
  connectors?: Array<IConnectorInfo>;
}
/**
 * Return equipment and the rule configuration from rule appi
 * @export
 * @interface IEquipmentRules
 */
export interface IEquipmentRules {
  /**
   *
   * @type {IEquipment}
   * @memberof IEquipmentRules
   */
  equipment?: IEquipment;
  /**
   * RuleConfiguration from rules api
   * @type {{ [key: string]: IRuleConfiguration; }}
   * @memberof IEquipmentRules
   */
  ruleConfiguration?: { [key: string]: IRuleConfiguration } | null;
}
/**
 * Equipment status and notes
 * @export
 * @interface IEquipmentStatusDto
 */
export interface IEquipmentStatusDto {
  /**
   *
   * @type {IEquipmentStatusType}
   * @memberof IEquipmentStatusDto
   */
  status: IEquipmentStatusType;
  /**
   *
   * @type {IElementNoteDto}
   * @memberof IEquipmentStatusDto
   */
  note: IElementNoteDto;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IEquipmentStatusType = {
  Active: "Active",
  Maintenance: "Maintenance",
} as const;

export type IEquipmentStatusType =
  typeof IEquipmentStatusType[keyof typeof IEquipmentStatusType];

/**
 *
 * @export
 * @interface IEvents
 */
export interface IEvents {
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  service?: string | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IEvents
   */
  activationConfiguration?: { [key: string]: any } | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IEvents
   */
  configuration?: { [key: string]: any } | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IEvents
   */
  elementTree: Array<string>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof IEvents
   */
  requirementTypeIds?: { [key: string]: string } | null;
  /**
   *
   * @type {boolean}
   * @memberof IEvents
   */
  deleted?: boolean;
  /**
   *
   * @type {number}
   * @memberof IEvents
   */
  slots?: number;
  /**
   *
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IEvents
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  timeZoneId: string;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  duration?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  recurringInterval?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  recurringCron?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  recurringStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEvents
   */
  recurringEnd?: string | null;
}
/**
 * Events
 * @export
 * @interface IEventsDto
 */
export interface IEventsDto {
  /**
   * Name
   * @type {string}
   * @memberof IEventsDto
   */
  name: string;
  /**
   * Service
   * @type {string}
   * @memberof IEventsDto
   */
  service?: string | null;
  /**
   * Activation Configuration
   * @type {{ [key: string]: any; }}
   * @memberof IEventsDto
   */
  activationConfiguration?: { [key: string]: any } | null;
  /**
   * Configuration
   * @type {{ [key: string]: any; }}
   * @memberof IEventsDto
   */
  configuration?: { [key: string]: any } | null;
  /**
   * Element tree
   * @type {Array<string>}
   * @memberof IEventsDto
   */
  elementTree?: Array<string> | null;
  /**
   * Rule requirements. The event must pass the rules defined by this requirement type before being allowed to enter the stage
   * @type {{ [key: string]: string; }}
   * @memberof IEventsDto
   */
  requirementTypeIds?: { [key: string]: string } | null;
  /**
   * The number of slots available for this group
   * @type {number}
   * @memberof IEventsDto
   */
  slots?: number | null;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IEventsDto
   */
  deleted?: boolean;
  /**
   * Customer specific information for display purposes. Business logic should not be done.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IEventsDto
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
  /**
   * The time zone identifier, which corresponds to the System.TimeZoneInfo.Id property. If  null, UTC time zone will be used.
   * @type {string}
   * @memberof IEventsDto
   */
  timeZoneId: string;
  /**
   * CRON expression when a schedule is recurring
   * @type {string}
   * @memberof IEventsDto
   */
  recurringCron?: string | null;
  /**
   * The CRON start time
   * @type {string}
   * @memberof IEventsDto
   */
  recurringStart?: string | null;
  /**
   * The CRON end time
   * @type {string}
   * @memberof IEventsDto
   */
  recurringEnd?: string | null;
  /**
   * Interval when a schedule is recurring
   * @type {string}
   * @memberof IEventsDto
   */
  recurringInterval?: string | null;
  /**
   * Duration of an event
   * @type {string}
   * @memberof IEventsDto
   */
  duration?: string | null;
}
/**
 * Events and events rule configuration. Equipment and equipment rule configuration
 * @export
 * @interface IEventsEquipmentRules
 */
export interface IEventsEquipmentRules {
  /**
   *
   * @type {IEventsRules}
   * @memberof IEventsEquipmentRules
   */
  eventsRules?: IEventsRules;
  /**
   * Equipment and RuleConfiguration
   * @type {Array<IEquipmentRules>}
   * @memberof IEventsEquipmentRules
   */
  equipmentRules?: Array<IEquipmentRules> | null;
}
/**
 *
 * @export
 * @interface IEventsEquipmentRulesIRadianseResult
 */
export interface IEventsEquipmentRulesIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IEventsEquipmentRules}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  data?: IEventsEquipmentRules;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEventsEquipmentRulesIRadianseResultSuccess
 */
export interface IEventsEquipmentRulesIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IEventsEquipmentRules}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  data: IEventsEquipmentRules;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEventsEquipmentRulesIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * Events
 * @export
 * @interface IEventsPatchDto
 */
export interface IEventsPatchDto {
  /**
   * Name
   * @type {string}
   * @memberof IEventsPatchDto
   */
  name?: string | null;
  /**
   * Duration of an event
   * @type {string}
   * @memberof IEventsPatchDto
   */
  duration?: string | null;
  /**
   * Service
   * @type {string}
   * @memberof IEventsPatchDto
   */
  service?: string | null;
  /**
   * Activation Configuration
   * @type {{ [key: string]: any; }}
   * @memberof IEventsPatchDto
   */
  activationConfiguration?: { [key: string]: any } | null;
  /**
   * Configuration
   * @type {{ [key: string]: any; }}
   * @memberof IEventsPatchDto
   */
  configuration?: { [key: string]: any } | null;
  /**
   * Element tree
   * @type {Array<string>}
   * @memberof IEventsPatchDto
   */
  elementTree?: Array<string> | null;
  /**
   * Rule requirements. The event must pass the rules defined by this requirement type before being allowed to enter the stage
   * @type {{ [key: string]: string; }}
   * @memberof IEventsPatchDto
   */
  requirementTypeIds?: { [key: string]: string } | null;
  /**
   * The number of slots available for this group
   * @type {number}
   * @memberof IEventsPatchDto
   */
  slots?: number | null;
  /**
   * Customer specific information for display purposes. Business logic should not be done.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IEventsPatchDto
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
  /**
   * The time zone identifier, which corresponds to the System.TimeZoneInfo.Id property. If  null, UTC time zone will be used. https://docs.microsoft.com/en-us/dotnet/api/system.timezoneinfo.id?view=net-5.0
   * @type {string}
   * @memberof IEventsPatchDto
   */
  timeZoneId?: string | null;
  /**
   * CRON expression when a schedule is recurring
   * @type {string}
   * @memberof IEventsPatchDto
   */
  recurringCron?: string | null;
  /**
   * The CRON start time
   * @type {string}
   * @memberof IEventsPatchDto
   */
  recurringStart?: string | null;
  /**
   * The CRON end time
   * @type {string}
   * @memberof IEventsPatchDto
   */
  recurringEnd?: string | null;
}
/**
 * Events and rule configuration
 * @export
 * @interface IEventsRules
 */
export interface IEventsRules {
  /**
   *
   * @type {IEvents}
   * @memberof IEventsRules
   */
  events?: IEvents;
  /**
   * Rule Configuration from rules api
   * @type {{ [key: string]: IRuleConfiguration; }}
   * @memberof IEventsRules
   */
  ruleConfiguration?: { [key: string]: IRuleConfiguration } | null;
}
/**
 *
 * @export
 * @interface IExpandoObjectIRadianseResult
 */
export interface IExpandoObjectIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IExpandoObjectIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IExpandoObjectIRadianseResult
   */
  data?: { [key: string]: any } | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IExpandoObjectIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IExpandoObjectIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IExpandoObjectIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IExpandoObjectIRadianseResultSuccess
 */
export interface IExpandoObjectIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  data: { [key: string]: any };
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IExpandoObjectListIRadianseResult
 */
export interface IExpandoObjectListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IExpandoObjectListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof IExpandoObjectListIRadianseResult
   */
  data?: Array<{ [key: string]: any }> | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IExpandoObjectListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IExpandoObjectListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IExpandoObjectListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IExpandoObjectListIRadianseResultSuccess
 */
export interface IExpandoObjectListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  data: Array<{ [key: string]: any }>;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IExpandoObjectListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IGenderType = {
  None: "None",
  Male: "Male",
  Female: "Female",
  Other: "Other",
  Unknown: "Unknown",
} as const;

export type IGenderType = typeof IGenderType[keyof typeof IGenderType];

/**
 *
 * @export
 * @enum {string}
 */

export const IHandlebarsDataType = {
  String: "String",
} as const;

export type IHandlebarsDataType =
  typeof IHandlebarsDataType[keyof typeof IHandlebarsDataType];

/**
 *
 * @export
 * @interface IHandlebarsType
 */
export interface IHandlebarsType {
  /**
   *
   * @type {string}
   * @memberof IHandlebarsType
   */
  expressionName?: string;
  /**
   *
   * @type {string}
   * @memberof IHandlebarsType
   */
  displayName?: string;
  /**
   *
   * @type {IHandlebarsDataType}
   * @memberof IHandlebarsType
   */
  type?: IHandlebarsDataType;
}
/**
 *
 * @export
 * @interface IIContact
 */
export interface IIContact {
  /**
   *
   * @type {string}
   * @memberof IIContact
   */
  salutation: string;
  /**
   *
   * @type {string}
   * @memberof IIContact
   */
  phoneNumber: string;
  /**
   *
   * @type {string}
   * @memberof IIContact
   */
  email: string;
}
/**
 *
 * @export
 * @interface IIContactIRadianseResult
 */
export interface IIContactIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IIContactIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IIContact}
   * @memberof IIContactIRadianseResult
   */
  data?: IIContact;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIContactIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIContactIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIContactIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIContactIRadianseResultSuccess
 */
export interface IIContactIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IIContactIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IIContact}
   * @memberof IIContactIRadianseResultSuccess
   */
  data: IIContact;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIContactIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIContactIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIContactIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIContactIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIContactListIRadianseResult
 */
export interface IIContactListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IIContactListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IIContact>}
   * @memberof IIContactListIRadianseResult
   */
  data?: Array<IIContact> | null;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIContactListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIContactListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIContactListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIContactListIRadianseResultSuccess
 */
export interface IIContactListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IIContactListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IIContact>}
   * @memberof IIContactListIRadianseResultSuccess
   */
  data: Array<IIContact>;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIContactListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIContactListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIContactListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIContactListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIEquipment
 */
export interface IIEquipment {
  /**
   *
   * @type {string}
   * @memberof IIEquipment
   */
  eventsId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipment
   */
  manufacturer: string;
  /**
   *
   * @type {string}
   * @memberof IIEquipment
   */
  model: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof IIEquipment
   */
  requirementTypeIds?: { [key: string]: string } | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipment
   */
  serialNumber?: string | null;
  /**
   *
   * @type {Array<IConnectorInfo>}
   * @memberof IIEquipment
   */
  connectors?: Array<IConnectorInfo>;
  /**
   *
   * @type {IEquipmentStatusType}
   * @memberof IIEquipment
   */
  status?: IEquipmentStatusType;
  /**
   *
   * @type {Array<string>}
   * @memberof IIEquipment
   */
  elementTree?: Array<string> | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IIEquipment
   */
  activationConfiguration?: { [key: string]: any } | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipment
   */
  name: string;
  /**
   *
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IIEquipment
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IIEquipment
   */
  configuration?: { [key: string]: any } | null;
}
/**
 *
 * @export
 * @interface IIEquipmentIRadianseResult
 */
export interface IIEquipmentIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IIEquipmentIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IIEquipment}
   * @memberof IIEquipmentIRadianseResult
   */
  data?: IIEquipment;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIEquipmentIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIEquipmentIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIEquipmentIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIEquipmentIRadianseResultSuccess
 */
export interface IIEquipmentIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IIEquipment}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  data: IIEquipment;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIEquipmentListIRadianseResult
 */
export interface IIEquipmentListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IIEquipmentListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IIEquipment>}
   * @memberof IIEquipmentListIRadianseResult
   */
  data?: Array<IIEquipment> | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIEquipmentListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIEquipmentListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIEquipmentListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIEquipmentListIRadianseResultSuccess
 */
export interface IIEquipmentListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IIEquipment>}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  data: Array<IIEquipment>;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEquipmentListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIEvents
 */
export interface IIEvents {
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IIEvents
   */
  activationConfiguration?: { [key: string]: any } | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IIEvents
   */
  configuration?: { [key: string]: any } | null;
  /**
   *
   * @type {string}
   * @memberof IIEvents
   */
  service?: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof IIEvents
   */
  requirementTypeIds?: { [key: string]: string } | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIEvents
   */
  elementTree?: Array<string> | null;
  /**
   *
   * @type {number}
   * @memberof IIEvents
   */
  slots?: number;
  /**
   *
   * @type {string}
   * @memberof IIEvents
   */
  timeZoneId: string;
  /**
   *
   * @type {string}
   * @memberof IIEvents
   */
  duration?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEvents
   */
  recurringInterval?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEvents
   */
  recurringCron?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEvents
   */
  recurringStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEvents
   */
  recurringEnd?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEvents
   */
  name: string;
  /**
   *
   * @type {boolean}
   * @memberof IIEvents
   */
  deleted?: boolean;
  /**
   *
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IIEvents
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
}
/**
 *
 * @export
 * @interface IIEventsIRadianseResult
 */
export interface IIEventsIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IIEventsIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IIEvents}
   * @memberof IIEventsIRadianseResult
   */
  data?: IIEvents;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIEventsIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIEventsIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIEventsIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIEventsIRadianseResultSuccess
 */
export interface IIEventsIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IIEventsIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IIEvents}
   * @memberof IIEventsIRadianseResultSuccess
   */
  data: IIEvents;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIEventsIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIEventsIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIEventsIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIEventsListIRadianseResult
 */
export interface IIEventsListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IIEventsListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IIEvents>}
   * @memberof IIEventsListIRadianseResult
   */
  data?: Array<IIEvents> | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIEventsListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIEventsListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIEventsListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIEventsListIRadianseResultSuccess
 */
export interface IIEventsListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IIEvents>}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  data: Array<IIEvents>;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIEventsListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIMember
 */
export interface IIMember {
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  agreementNumber: string;
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  birthDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  firstName?: string | null;
  /**
   *
   * @type {IGenderType}
   * @memberof IIMember
   */
  gender?: IGenderType;
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  middleName?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  salutation?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  suffix?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  email?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMember
   */
  barcode?: string;
}
/**
 *
 * @export
 * @interface IIMemberIRadianseResult
 */
export interface IIMemberIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IIMemberIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IIMember}
   * @memberof IIMemberIRadianseResult
   */
  data?: IIMember;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIMemberIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIMemberIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIMemberIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIMemberIRadianseResultSuccess
 */
export interface IIMemberIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IIMemberIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IIMember}
   * @memberof IIMemberIRadianseResultSuccess
   */
  data: IIMember;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIMemberIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIMemberIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIMemberIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIMemberIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IImageSizeType = {
  Original: "Original",
  Thumbnail: "Thumbnail",
  Small: "Small",
  Medium: "Medium",
  Large: "Large",
} as const;

export type IImageSizeType = typeof IImageSizeType[keyof typeof IImageSizeType];

/**
 *
 * @export
 * @enum {string}
 */

export const IImportType = {
  Abc: "ABC",
} as const;

export type IImportType = typeof IImportType[keyof typeof IImportType];

/**
 *
 * @export
 * @interface ILanguage
 */
export interface ILanguage {
  /**
   *
   * @type {string}
   * @memberof ILanguage
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ILanguage
   */
  name: string;
}
/**
 *
 * @export
 * @interface ILanguageIRadianseResult
 */
export interface ILanguageIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof ILanguageIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {ILanguage}
   * @memberof ILanguageIRadianseResult
   */
  data?: ILanguage;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ILanguageIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof ILanguageIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof ILanguageIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface ILanguageIRadianseResultSuccess
 */
export interface ILanguageIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof ILanguageIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {ILanguage}
   * @memberof ILanguageIRadianseResultSuccess
   */
  data: ILanguage;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ILanguageIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof ILanguageIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof ILanguageIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof ILanguageIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ILogicalOperatorType = {
  And: "And",
  Or: "Or",
} as const;

export type ILogicalOperatorType =
  typeof ILogicalOperatorType[keyof typeof ILogicalOperatorType];

/**
 * Member
 * @export
 * @interface IMemberDto
 */
export interface IMemberDto {
  /**
   * Name
   * @type {string}
   * @memberof IMemberDto
   */
  name: string;
  /**
   * Birthdate
   * @type {string}
   * @memberof IMemberDto
   */
  birthDate?: string | null;
  /**
   * First name
   * @type {string}
   * @memberof IMemberDto
   */
  firstName?: string | null;
  /**
   *
   * @type {IGenderType}
   * @memberof IMemberDto
   */
  gender?: IGenderType;
  /**
   * Last name
   * @type {string}
   * @memberof IMemberDto
   */
  lastName: string;
  /**
   * Middle name
   * @type {string}
   * @memberof IMemberDto
   */
  middleName?: string | null;
  /**
   * Salutation
   * @type {string}
   * @memberof IMemberDto
   */
  salutation?: string | null;
  /**
   * Suffix
   * @type {string}
   * @memberof IMemberDto
   */
  suffix?: string | null;
  /**
   * Global
   * @type {boolean}
   * @memberof IMemberDto
   */
  global?: boolean | null;
  /**
   * Connector information.
   * @type {Array<IConnectorInfo>}
   * @memberof IMemberDto
   */
  connectors?: Array<IConnectorInfo>;
  /**
   * Bar code
   * @type {string}
   * @memberof IMemberDto
   */
  barcode: string;
  /**
   * Club code
   * @type {string}
   * @memberof IMemberDto
   */
  clubCode: string;
  /**
   * Active
   * @type {boolean}
   * @memberof IMemberDto
   */
  active?: boolean;
  /**
   *
   * @type {IAddressType}
   * @memberof IMemberDto
   */
  addressType?: IAddressType;
  /**
   * Street
   * @type {string}
   * @memberof IMemberDto
   */
  street1?: string | null;
  /**
   * Street line 2
   * @type {string}
   * @memberof IMemberDto
   */
  street2?: string | null;
  /**
   * City
   * @type {string}
   * @memberof IMemberDto
   */
  city?: string | null;
  /**
   * Postal code
   * @type {string}
   * @memberof IMemberDto
   */
  postalCode: string;
  /**
   * SUBDIVISION CODE (ISO 3166-2). For example \"US-NH\"
   * @type {string}
   * @memberof IMemberDto
   */
  subdivisionCode?: string | null;
  /**
   * Country code as specified by the ISO 3166. For example \"US\"
   * @type {string}
   * @memberof IMemberDto
   */
  countryCode?: string | null;
  /**
   * Email
   * @type {string}
   * @memberof IMemberDto
   */
  email?: string | null;
  /**
   * Phone number
   * @type {string}
   * @memberof IMemberDto
   */
  phoneNumber?: string | null;
  /**
   * Cell phone provider
   * @type {string}
   * @memberof IMemberDto
   */
  cellPhoneProvider?: string | null;
  /**
   * Agreement number
   * @type {string}
   * @memberof IMemberDto
   */
  agreementNumber: string;
  /**
   * Has suitable credit
   * @type {boolean}
   * @memberof IMemberDto
   */
  hasSuitableCredit?: boolean;
  /**
   * In good standing
   * @type {boolean}
   * @memberof IMemberDto
   */
  inGoodStanding?: boolean;
  /**
   * Last updated
   * @type {string}
   * @memberof IMemberDto
   */
  lastUpdate?: string;
  /**
   * Member type
   * @type {string}
   * @memberof IMemberDto
   */
  memberType: string;
  /**
   * Guid of service access type
   * @type {string}
   * @memberof IMemberDto
   */
  serviceAccessTypeId?: string;
  /**
   * History
   * @type {Array<{ [key: string]: any; }>}
   * @memberof IMemberDto
   */
  history?: Array<{ [key: string]: any }> | null;
}
/**
 *
 * @export
 * @interface IMetaDataInfo
 */
export interface IMetaDataInfo {
  /**
   *
   * @type {any}
   * @memberof IMetaDataInfo
   */
  data?: any;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IModelConfigType = {
  Unknown: "Unknown",
  Progression: "Progression",
} as const;

export type IModelConfigType =
  typeof IModelConfigType[keyof typeof IModelConfigType];

/**
 *
 * @export
 * @interface IModelConfiguration
 */
export interface IModelConfiguration {
  /**
   *
   * @type {string}
   * @memberof IModelConfiguration
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfiguration
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IModelConfiguration
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IModelConfiguration
   */
  manufacturer: string;
  /**
   *
   * @type {string}
   * @memberof IModelConfiguration
   */
  model: string;
  /**
   *
   * @type {string}
   * @memberof IModelConfiguration
   */
  partitionKey?: string | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof IModelConfiguration
   */
  configuration: { [key: string]: any };
  /**
   *
   * @type {IModelConfigType}
   * @memberof IModelConfiguration
   */
  type: IModelConfigType;
  /**
   *
   * @type {boolean}
   * @memberof IModelConfiguration
   */
  deleted?: boolean;
}
/**
 * Model configuration
 * @export
 * @interface IModelConfigurationDto
 */
export interface IModelConfigurationDto {
  /**
   * Manufacturer
   * @type {string}
   * @memberof IModelConfigurationDto
   */
  manufacturer: string;
  /**
   * Model
   * @type {string}
   * @memberof IModelConfigurationDto
   */
  model: string;
  /**
   * Configuration
   * @type {{ [key: string]: any; }}
   * @memberof IModelConfigurationDto
   */
  configuration: { [key: string]: any };
  /**
   *
   * @type {IModelConfigType}
   * @memberof IModelConfigurationDto
   */
  type: IModelConfigType;
}
/**
 *
 * @export
 * @interface IModelConfigurationIRadianseResult
 */
export interface IModelConfigurationIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IModelConfigurationIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IModelConfiguration}
   * @memberof IModelConfigurationIRadianseResult
   */
  data?: IModelConfiguration;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IModelConfigurationIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IModelConfigurationIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IModelConfigurationIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IModelConfigurationIRadianseResultSuccess
 */
export interface IModelConfigurationIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IModelConfiguration}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  data: IModelConfiguration;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IModelConfigurationListIRadianseResult
 */
export interface IModelConfigurationListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IModelConfigurationListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IModelConfiguration>}
   * @memberof IModelConfigurationListIRadianseResult
   */
  data?: Array<IModelConfiguration> | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IModelConfigurationListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IModelConfigurationListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IModelConfigurationListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IModelConfigurationListIRadianseResultSuccess
 */
export interface IModelConfigurationListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IModelConfiguration>}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  data: Array<IModelConfiguration>;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IModelConfigurationListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IQueryOperatorType = {
  Equals: "Equals",
  LessThan: "LessThan",
  LessThanOrEquals: "LessThanOrEquals",
  GreaterThan: "GreaterThan",
  GreaterThanOrEquals: "GreaterThanOrEquals",
  NotEquals: "NotEquals",
  NotNull: "NotNull",
  IsNull: "IsNull",
  IsDefined: "IsDefined",
  NotDefined: "NotDefined",
  IsNotNullAndIsDefined: "IsNotNullAndIsDefined",
  IsNullOrNotIsDefined: "IsNullOrNotIsDefined",
} as const;

export type IQueryOperatorType =
  typeof IQueryOperatorType[keyof typeof IQueryOperatorType];

/**
 *
 * @export
 * @interface IRateLimited
 */
export interface IRateLimited {
  /**
   *
   * @type {number}
   * @memberof IRateLimited
   */
  restrictionLimitInMinutes: number;
  /**
   *
   * @type {number}
   * @memberof IRateLimited
   */
  restrictionLimitFrequency: number;
}
/**
 *
 * @export
 * @interface IRuleConfigRequiredOperator
 */
export interface IRuleConfigRequiredOperator {
  /**
   *
   * @type {boolean}
   * @memberof IRuleConfigRequiredOperator
   */
  required?: boolean;
}
/**
 *
 * @export
 * @interface IRuleConfiguration
 */
export interface IRuleConfiguration {
  /**
   *
   * @type {string}
   * @memberof IRuleConfiguration
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IRuleConfiguration
   */
  partitionKey: string;
  /**
   *
   * @type {string}
   * @memberof IRuleConfiguration
   */
  category?: string | null;
  /**
   *
   * @type {string}
   * @memberof IRuleConfiguration
   */
  subCategory?: string | null;
  /**
   *
   * @type {string}
   * @memberof IRuleConfiguration
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof IRuleConfiguration
   */
  minimumAge?: number | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IRuleConfiguration
   */
  allowedMembershipTypes?: Array<string> | null;
  /**
   *
   * @type {number}
   * @memberof IRuleConfiguration
   */
  milesFromLocation?: number | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IRuleConfiguration
   */
  requiredDocuments?: Array<string> | null;
  /**
   *
   * @type {Array<IDocumentWeightedRule>}
   * @memberof IRuleConfiguration
   */
  conditionallyRequiredDocuments?: Array<IDocumentWeightedRule> | null;
  /**
   *
   * @type {{ [key: string]: ITimeRestriction; }}
   * @memberof IRuleConfiguration
   */
  timeRestrictions?: { [key: string]: ITimeRestriction } | null;
  /**
   *
   * @type {IRateLimited}
   * @memberof IRuleConfiguration
   */
  rateLimited?: IRateLimited;
  /**
   *
   * @type {IRuleServicesConfig}
   * @memberof IRuleConfiguration
   */
  servicesConfig?: IRuleServicesConfig;
  /**
   *
   * @type {Array<IRuleDynamicConfig>}
   * @memberof IRuleConfiguration
   */
  dynamicRules?: Array<IRuleDynamicConfig> | null;
  /**
   *
   * @type {Array<IDocumentTemplateRequirements>}
   * @memberof IRuleConfiguration
   */
  templateRequirements?: Array<IDocumentTemplateRequirements> | null;
  /**
   *
   * @type {IRuleConfigRequiredOperator}
   * @memberof IRuleConfiguration
   */
  operator?: IRuleConfigRequiredOperator;
  /**
   *
   * @type {boolean}
   * @memberof IRuleConfiguration
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IRuleDataType = {
  Boolean: "Boolean",
  DateTime: "DateTime",
  DateTimeOffset: "DateTimeOffset",
  Double: "Double",
  Guid: "Guid",
  Int32: "Int32",
  Int64: "Int64",
  String: "String",
} as const;

export type IRuleDataType = typeof IRuleDataType[keyof typeof IRuleDataType];

/**
 *
 * @export
 * @interface IRuleDynamicConfig
 */
export interface IRuleDynamicConfig {
  /**
   *
   * @type {IRuleDynamicElementType}
   * @memberof IRuleDynamicConfig
   */
  elementType: IRuleDynamicElementType;
  /**
   *
   * @type {Array<IRuleDynamicRules>}
   * @memberof IRuleDynamicConfig
   */
  rules: Array<IRuleDynamicRules>;
}
/**
 *
 * @export
 * @interface IRuleDynamicElementType
 */
export interface IRuleDynamicElementType {
  /**
   *
   * @type {string}
   * @memberof IRuleDynamicElementType
   */
  field: string;
  /**
   *
   * @type {string}
   * @memberof IRuleDynamicElementType
   */
  value: string;
}
/**
 *
 * @export
 * @interface IRuleDynamicRules
 */
export interface IRuleDynamicRules {
  /**
   *
   * @type {IRuleTriggerType}
   * @memberof IRuleDynamicRules
   */
  trigger: IRuleTriggerType;
  /**
   *
   * @type {string}
   * @memberof IRuleDynamicRules
   */
  field: string;
  /**
   *
   * @type {IRuleDataType}
   * @memberof IRuleDynamicRules
   */
  type: IRuleDataType;
  /**
   *
   * @type {IRuleOperatorType}
   * @memberof IRuleDynamicRules
   */
  operator: IRuleOperatorType;
  /**
   *
   * @type {any}
   * @memberof IRuleDynamicRules
   */
  value: any;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IRuleOperatorType = {
  Any: "Any",
  Equals: "Equals",
  Contains: "Contains",
  BeginsWith: "BeginsWith",
  EndsWith: "EndsWith",
  LessThan: "LessThan",
  LessThanOrEquals: "LessThanOrEquals",
  GreaterThan: "GreaterThan",
  GreaterThanOrEquals: "GreaterThanOrEquals",
  NotAny: "NotAny",
  NotEquals: "NotEquals",
  NotContains: "NotContains",
  NotBeginsWith: "NotBeginsWith",
  NotEndsWith: "NotEndsWith",
  NotLessThan: "NotLessThan",
  NotLessThanOrEquals: "NotLessThanOrEquals",
  NotGreaterThan: "NotGreaterThan",
  NotGreaterThanOrEquals: "NotGreaterThanOrEquals",
} as const;

export type IRuleOperatorType =
  typeof IRuleOperatorType[keyof typeof IRuleOperatorType];

/**
 *
 * @export
 * @interface IRuleServicesConfig
 */
export interface IRuleServicesConfig {
  /**
   *
   * @type {Array<string>}
   * @memberof IRuleServicesConfig
   */
  services: Array<string>;
  /**
   *
   * @type {ILogicalOperatorType}
   * @memberof IRuleServicesConfig
   */
  logicalOperator: ILogicalOperatorType;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IRuleTriggerType = {
  And: "And",
  Or: "Or",
} as const;

export type IRuleTriggerType =
  typeof IRuleTriggerType[keyof typeof IRuleTriggerType];

/**
 *
 * @export
 * @interface ISearchListItem
 */
export interface ISearchListItem {
  /**
   *
   * @type {string}
   * @memberof ISearchListItem
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItem
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItem
   */
  category?: string | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItem
   */
  subCategory?: string | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItem
   */
  name?: string | null;
}
/**
 *
 * @export
 * @interface ISearchListItemListIRadianseResult
 */
export interface ISearchListItemListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof ISearchListItemListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<ISearchListItem>}
   * @memberof ISearchListItemListIRadianseResult
   */
  data?: Array<ISearchListItem> | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ISearchListItemListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof ISearchListItemListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof ISearchListItemListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface ISearchListItemListIRadianseResultSuccess
 */
export interface ISearchListItemListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<ISearchListItem>}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  data: Array<ISearchListItem>;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof ISearchListItemListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IServiceAccessType
 */
export interface IServiceAccessType {
  /**
   *
   * @type {string}
   * @memberof IServiceAccessType
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessType
   */
  partitionKey?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessType
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessType
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessType
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessType
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessType
   */
  code?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof IServiceAccessType
   */
  accessRestriction?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof IServiceAccessType
   */
  allowRemoteCheckin?: boolean | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IServiceAccessType
   */
  services: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof IServiceAccessType
   */
  deleted?: boolean | null;
}
/**
 * ServiceAccessType
 * @export
 * @interface IServiceAccessTypeDto
 */
export interface IServiceAccessTypeDto {
  /**
   * Name
   * @type {string}
   * @memberof IServiceAccessTypeDto
   */
  name: string;
  /**
   * Description name
   * @type {string}
   * @memberof IServiceAccessTypeDto
   */
  description?: string;
  /**
   * Code
   * @type {string}
   * @memberof IServiceAccessTypeDto
   */
  code?: string;
  /**
   * AccessRestriction
   * @type {boolean}
   * @memberof IServiceAccessTypeDto
   */
  accessRestriction?: boolean;
  /**
   * Allow remote checkin
   * @type {boolean}
   * @memberof IServiceAccessTypeDto
   */
  allowRemoteCheckin?: boolean;
  /**
   * Services
   * @type {Array<string>}
   * @memberof IServiceAccessTypeDto
   */
  services: Array<string>;
}
/**
 *
 * @export
 * @interface IServiceAccessTypeIRadianseResult
 */
export interface IServiceAccessTypeIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IServiceAccessType}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  data?: IServiceAccessType;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IServiceAccessTypeIRadianseResultSuccess
 */
export interface IServiceAccessTypeIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IServiceAccessType}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  data: IServiceAccessType;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IServiceAccessTypeListIRadianseResult
 */
export interface IServiceAccessTypeListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IServiceAccessType>}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  data?: Array<IServiceAccessType> | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IServiceAccessTypeListIRadianseResultSuccess
 */
export interface IServiceAccessTypeListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IServiceAccessType>}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  data: Array<IServiceAccessType>;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceAccessTypeListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IServiceList
 */
export interface IServiceList {
  /**
   *
   * @type {string}
   * @memberof IServiceList
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceList
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceList
   */
  category?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceList
   */
  subCategory?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IServiceList
   */
  services: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof IServiceList
   */
  deleted?: boolean | null;
}
/**
 * ServiceAccessTypeServices
 * @export
 * @interface IServiceListDto
 */
export interface IServiceListDto {
  /**
   * Unique list of services across all service access type
   * @type {Array<string>}
   * @memberof IServiceListDto
   */
  services?: Array<string>;
}
/**
 *
 * @export
 * @interface IServiceListIRadianseResult
 */
export interface IServiceListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IServiceListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IServiceList}
   * @memberof IServiceListIRadianseResult
   */
  data?: IServiceList;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IServiceListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IServiceListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IServiceListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IServiceListIRadianseResultSuccess
 */
export interface IServiceListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IServiceListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IServiceList}
   * @memberof IServiceListIRadianseResultSuccess
   */
  data: IServiceList;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IServiceListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IServiceListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IServiceListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IServiceListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IStringIRadianseResult
 */
export interface IStringIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IStringIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  data?: string | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IStringIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IStringIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface ITimeRestriction
 */
export interface ITimeRestriction {
  /**
   *
   * @type {Array<string>}
   * @memberof ITimeRestriction
   */
  restrictedTypes: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ITimeRestriction
   */
  restrictionTimeInMinutes: number;
  /**
   *
   * @type {number}
   * @memberof ITimeRestriction
   */
  maximumOccurancesPerTimespan: number;
  /**
   *
   * @type {ITimeRestrictionElementType}
   * @memberof ITimeRestriction
   */
  elementType: ITimeRestrictionElementType;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ITimeRestrictionElementType = {
  ElementTree: "ElementTree",
  Events: "Events",
} as const;

export type ITimeRestrictionElementType =
  typeof ITimeRestrictionElementType[keyof typeof ITimeRestrictionElementType];

/**
 * ConnectorApi - axios parameter creator
 * @export
 */
export const ConnectorApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: connector_read
     * @summary Get all Connector
     * @param {boolean} [deleted]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorGet: async (
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Connector`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: connector_delete
     * @summary Delete Connector
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorIdDelete: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiConnectorIdDelete", "id", id);
      const localVarPath = `/UserApi/Connector/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: connector_read
     * @summary Get Connector by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorIdGet: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiConnectorIdGet", "id", id);
      const localVarPath = `/UserApi/Connector/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: connector_create
     * @summary Create or edit Connector
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IConnectorDto} [iConnectorDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorIdPut: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iConnectorDto?: IConnectorDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiConnectorIdPut", "id", id);
      const localVarPath = `/UserApi/Connector/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iConnectorDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: connector_create
     * @summary Create Connector
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IConnectorDto} [iConnectorDto] Connector to create. Connector.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorPost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iConnectorDto?: IConnectorDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Connector`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iConnectorDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ConnectorApi - functional programming interface
 * @export
 */
export const ConnectorApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ConnectorApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: connector_read
     * @summary Get all Connector
     * @param {boolean} [deleted]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiConnectorGet(
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IConnectorListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiConnectorGet(
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: connector_delete
     * @summary Delete Connector
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiConnectorIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IConnectorIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiConnectorIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: connector_read
     * @summary Get Connector by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiConnectorIdGet(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IConnectorIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiConnectorIdGet(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: connector_create
     * @summary Create or edit Connector
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IConnectorDto} [iConnectorDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiConnectorIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iConnectorDto?: IConnectorDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IConnectorIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiConnectorIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iConnectorDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: connector_create
     * @summary Create Connector
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IConnectorDto} [iConnectorDto] Connector to create. Connector.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiConnectorPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iConnectorDto?: IConnectorDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IConnectorIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiConnectorPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iConnectorDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ConnectorApi - factory interface
 * @export
 */
export const ConnectorApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ConnectorApiFp(configuration);
  return {
    /**
     * Permission: connector_read
     * @summary Get all Connector
     * @param {boolean} [deleted]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorGet(
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IConnectorListIRadianseResultSuccess> {
      return localVarFp
        .userApiConnectorGet(
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: connector_delete
     * @summary Delete Connector
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IConnectorIRadianseResultSuccess> {
      return localVarFp
        .userApiConnectorIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: connector_read
     * @summary Get Connector by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorIdGet(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IConnectorIRadianseResultSuccess> {
      return localVarFp
        .userApiConnectorIdGet(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: connector_create
     * @summary Create or edit Connector
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IConnectorDto} [iConnectorDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iConnectorDto?: IConnectorDto,
      options?: any
    ): AxiosPromise<IConnectorIRadianseResultSuccess> {
      return localVarFp
        .userApiConnectorIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iConnectorDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: connector_create
     * @summary Create Connector
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IConnectorDto} [iConnectorDto] Connector to create. Connector.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiConnectorPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iConnectorDto?: IConnectorDto,
      options?: any
    ): AxiosPromise<IConnectorIRadianseResultSuccess> {
      return localVarFp
        .userApiConnectorPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iConnectorDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ConnectorApi - object-oriented interface
 * @export
 * @class ConnectorApi
 * @extends {BaseAPI}
 */
export class ConnectorApi extends BaseAPI {
  /**
   * Permission: connector_read
   * @summary Get all Connector
   * @param {boolean} [deleted]
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectorApi
   */
  public userApiConnectorGet(
    deleted?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ConnectorApiFp(this.configuration)
      .userApiConnectorGet(
        deleted,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: connector_delete
   * @summary Delete Connector
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectorApi
   */
  public userApiConnectorIdDelete(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ConnectorApiFp(this.configuration)
      .userApiConnectorIdDelete(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: connector_read
   * @summary Get Connector by id
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectorApi
   */
  public userApiConnectorIdGet(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ConnectorApiFp(this.configuration)
      .userApiConnectorIdGet(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: connector_create
   * @summary Create or edit Connector
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IConnectorDto} [iConnectorDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectorApi
   */
  public userApiConnectorIdPut(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iConnectorDto?: IConnectorDto,
    options?: AxiosRequestConfig
  ) {
    return ConnectorApiFp(this.configuration)
      .userApiConnectorIdPut(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iConnectorDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: connector_create
   * @summary Create Connector
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IConnectorDto} [iConnectorDto] Connector to create. Connector.Id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectorApi
   */
  public userApiConnectorPost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iConnectorDto?: IConnectorDto,
    options?: AxiosRequestConfig
  ) {
    return ConnectorApiFp(this.configuration)
      .userApiConnectorPost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iConnectorDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: contact_read                When using bearer token, groupId or tenantId is required
     * @summary Get list of all contacts
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactGet: async (
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Contact`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: contact_delete
     * @summary Delete Contact
     * @param {string} id Contact ID
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactIdDelete: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiContactIdDelete", "id", id);
      const localVarPath = `/UserApi/Contact/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: contact_read
     * @summary Get Contact by ID
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactIdGet: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiContactIdGet", "id", id);
      const localVarPath = `/UserApi/Contact/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: contact_edit
     * @summary Update Contact
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IContactDto} [iContactDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactIdPut: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iContactDto?: IContactDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiContactIdPut", "id", id);
      const localVarPath = `/UserApi/Contact/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iContactDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: contact_create
     * @summary Create Contact
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IContactDto} [iContactDto] Contact.id will be set to random guid. Contact.PartitionKey &#x3D; TenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactPost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iContactDto?: IContactDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Contact`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iContactDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: contact_read                When using bearer token, groupId or tenantId is required
     * @summary Get list of all contacts
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiContactGet(
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIContactListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiContactGet(
          clientTreeType,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: contact_delete
     * @summary Delete Contact
     * @param {string} id Contact ID
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiContactIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIContactIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiContactIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: contact_read
     * @summary Get Contact by ID
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiContactIdGet(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIContactIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiContactIdGet(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: contact_edit
     * @summary Update Contact
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IContactDto} [iContactDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiContactIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iContactDto?: IContactDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIContactIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiContactIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iContactDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: contact_create
     * @summary Create Contact
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IContactDto} [iContactDto] Contact.id will be set to random guid. Contact.PartitionKey &#x3D; TenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiContactPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iContactDto?: IContactDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIContactIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiContactPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iContactDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContactApiFp(configuration);
  return {
    /**
     * Permission: contact_read                When using bearer token, groupId or tenantId is required
     * @summary Get list of all contacts
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactGet(
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIContactListIRadianseResultSuccess> {
      return localVarFp
        .userApiContactGet(
          clientTreeType,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: contact_delete
     * @summary Delete Contact
     * @param {string} id Contact ID
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIContactIRadianseResultSuccess> {
      return localVarFp
        .userApiContactIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: contact_read
     * @summary Get Contact by ID
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactIdGet(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIContactIRadianseResultSuccess> {
      return localVarFp
        .userApiContactIdGet(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: contact_edit
     * @summary Update Contact
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IContactDto} [iContactDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iContactDto?: IContactDto,
      options?: any
    ): AxiosPromise<IIContactIRadianseResultSuccess> {
      return localVarFp
        .userApiContactIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iContactDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: contact_create
     * @summary Create Contact
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IContactDto} [iContactDto] Contact.id will be set to random guid. Contact.PartitionKey &#x3D; TenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiContactPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iContactDto?: IContactDto,
      options?: any
    ): AxiosPromise<IIContactIRadianseResultSuccess> {
      return localVarFp
        .userApiContactPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iContactDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
  /**
   * Permission: contact_read                When using bearer token, groupId or tenantId is required
   * @summary Get list of all contacts
   * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
   * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public userApiContactGet(
    clientTreeType?: IClientTreeType,
    deleted?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ContactApiFp(this.configuration)
      .userApiContactGet(
        clientTreeType,
        deleted,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: contact_delete
   * @summary Delete Contact
   * @param {string} id Contact ID
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public userApiContactIdDelete(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ContactApiFp(this.configuration)
      .userApiContactIdDelete(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: contact_read
   * @summary Get Contact by ID
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public userApiContactIdGet(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ContactApiFp(this.configuration)
      .userApiContactIdGet(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: contact_edit
   * @summary Update Contact
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IContactDto} [iContactDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public userApiContactIdPut(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iContactDto?: IContactDto,
    options?: AxiosRequestConfig
  ) {
    return ContactApiFp(this.configuration)
      .userApiContactIdPut(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iContactDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: contact_create
   * @summary Create Contact
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IContactDto} [iContactDto] Contact.id will be set to random guid. Contact.PartitionKey &#x3D; TenantId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public userApiContactPost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iContactDto?: IContactDto,
    options?: AxiosRequestConfig
  ) {
    return ContactApiFp(this.configuration)
      .userApiContactPost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iContactDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ElementManagerApi - axios parameter creator
 * @export
 */
export const ElementManagerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: equipment_status_edit                Notes will get added to endpoint ElementNotes
     * @summary Modify status of equipment and notify schedules and availability and add notes
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentStatusDto} [iEquipmentStatusDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementManagerEquipmentStatusIdPut: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentStatusDto?: IEquipmentStatusDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiElementManagerEquipmentStatusIdPut", "id", id);
      const localVarPath =
        `/UserApi/ElementManager/Equipment/Status/{id}`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEquipmentStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: events_read                Get rulesConfiguration from rules api.
     * @summary Get events by id, include also the equipment and ruleConfiguration for stage = Schedule
     * @param {string} id Events ID
     * @param {boolean} [forceReread] Read from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiElementManagerEventsRulesAndEquipmentIdGet: async (
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiElementManagerEventsRulesAndEquipmentIdGet",
        "id",
        id
      );
      const localVarPath =
        `/UserApi/ElementManager/Events/RulesAndEquipment/{id}`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (forceReread !== undefined) {
        localVarQueryParameter["forceReread"] = forceReread;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ElementManagerApi - functional programming interface
 * @export
 */
export const ElementManagerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ElementManagerApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: equipment_status_edit                Notes will get added to endpoint ElementNotes
     * @summary Modify status of equipment and notify schedules and availability and add notes
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentStatusDto} [iEquipmentStatusDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementManagerEquipmentStatusIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentStatusDto?: IEquipmentStatusDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementManagerEquipmentStatusIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentStatusDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: events_read                Get rulesConfiguration from rules api.
     * @summary Get events by id, include also the equipment and ruleConfiguration for stage = Schedule
     * @param {string} id Events ID
     * @param {boolean} [forceReread] Read from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiElementManagerEventsRulesAndEquipmentIdGet(
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEventsEquipmentRulesIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementManagerEventsRulesAndEquipmentIdGet(
          id,
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ElementManagerApi - factory interface
 * @export
 */
export const ElementManagerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ElementManagerApiFp(configuration);
  return {
    /**
     * Permission: equipment_status_edit                Notes will get added to endpoint ElementNotes
     * @summary Modify status of equipment and notify schedules and availability and add notes
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentStatusDto} [iEquipmentStatusDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementManagerEquipmentStatusIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentStatusDto?: IEquipmentStatusDto,
      options?: any
    ): AxiosPromise<IIEquipmentIRadianseResultSuccess> {
      return localVarFp
        .userApiElementManagerEquipmentStatusIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentStatusDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: events_read                Get rulesConfiguration from rules api.
     * @summary Get events by id, include also the equipment and ruleConfiguration for stage = Schedule
     * @param {string} id Events ID
     * @param {boolean} [forceReread] Read from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiElementManagerEventsRulesAndEquipmentIdGet(
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEventsEquipmentRulesIRadianseResultSuccess> {
      return localVarFp
        .userApiElementManagerEventsRulesAndEquipmentIdGet(
          id,
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ElementManagerApi - object-oriented interface
 * @export
 * @class ElementManagerApi
 * @extends {BaseAPI}
 */
export class ElementManagerApi extends BaseAPI {
  /**
   * Permission: equipment_status_edit                Notes will get added to endpoint ElementNotes
   * @summary Modify status of equipment and notify schedules and availability and add notes
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEquipmentStatusDto} [iEquipmentStatusDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementManagerApi
   */
  public userApiElementManagerEquipmentStatusIdPut(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEquipmentStatusDto?: IEquipmentStatusDto,
    options?: AxiosRequestConfig
  ) {
    return ElementManagerApiFp(this.configuration)
      .userApiElementManagerEquipmentStatusIdPut(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iEquipmentStatusDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: events_read                Get rulesConfiguration from rules api.
   * @summary Get events by id, include also the equipment and ruleConfiguration for stage = Schedule
   * @param {string} id Events ID
   * @param {boolean} [forceReread] Read from cache or database. Defaults to read from database
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof ElementManagerApi
   */
  public userApiElementManagerEventsRulesAndEquipmentIdGet(
    id: string,
    forceReread?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementManagerApiFp(this.configuration)
      .userApiElementManagerEventsRulesAndEquipmentIdGet(
        id,
        forceReread,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ElementNoteApi - axios parameter creator
 * @export
 */
export const ElementNoteApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: elementnotes_read
     * @summary Get all ElementNotes
     * @param {string} [elementId] The element id associated with the notes. This would be equipment id for equipment.
     * @param {string} [firstTimeValue] Query by TimeStamp and apply firstTimeOperator. For example TimeStamp &gt;&#x3D; 2022-11-01.
     * @param {IQueryOperatorType} [firstTimeOperator]
     * @param {string} [secondTimeValue] Query by TimeStamp and apply SecondTimeOperator. For example TimeStamp &lt;&#x3D; 2022-12-01.
     * @param {IQueryOperatorType} [secondTimeOperator]
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementNotesGet: async (
      elementId?: string,
      firstTimeValue?: string,
      firstTimeOperator?: IQueryOperatorType,
      secondTimeValue?: string,
      secondTimeOperator?: IQueryOperatorType,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ElementNotes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (elementId !== undefined) {
        localVarQueryParameter["elementId"] = elementId;
      }

      if (firstTimeValue !== undefined) {
        localVarQueryParameter["firstTimeValue"] =
          (firstTimeValue as any) instanceof Date
            ? (firstTimeValue as any).toISOString()
            : firstTimeValue;
      }

      if (firstTimeOperator !== undefined) {
        localVarQueryParameter["firstTimeOperator"] = firstTimeOperator;
      }

      if (secondTimeValue !== undefined) {
        localVarQueryParameter["secondTimeValue"] =
          (secondTimeValue as any) instanceof Date
            ? (secondTimeValue as any).toISOString()
            : secondTimeValue;
      }

      if (secondTimeOperator !== undefined) {
        localVarQueryParameter["secondTimeOperator"] = secondTimeOperator;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ElementNoteApi - functional programming interface
 * @export
 */
export const ElementNoteApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ElementNoteApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: elementnotes_read
     * @summary Get all ElementNotes
     * @param {string} [elementId] The element id associated with the notes. This would be equipment id for equipment.
     * @param {string} [firstTimeValue] Query by TimeStamp and apply firstTimeOperator. For example TimeStamp &gt;&#x3D; 2022-11-01.
     * @param {IQueryOperatorType} [firstTimeOperator]
     * @param {string} [secondTimeValue] Query by TimeStamp and apply SecondTimeOperator. For example TimeStamp &lt;&#x3D; 2022-12-01.
     * @param {IQueryOperatorType} [secondTimeOperator]
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementNotesGet(
      elementId?: string,
      firstTimeValue?: string,
      firstTimeOperator?: IQueryOperatorType,
      secondTimeValue?: string,
      secondTimeOperator?: IQueryOperatorType,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IElementNoteListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementNotesGet(
          elementId,
          firstTimeValue,
          firstTimeOperator,
          secondTimeValue,
          secondTimeOperator,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ElementNoteApi - factory interface
 * @export
 */
export const ElementNoteApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ElementNoteApiFp(configuration);
  return {
    /**
     * Permission: elementnotes_read
     * @summary Get all ElementNotes
     * @param {string} [elementId] The element id associated with the notes. This would be equipment id for equipment.
     * @param {string} [firstTimeValue] Query by TimeStamp and apply firstTimeOperator. For example TimeStamp &gt;&#x3D; 2022-11-01.
     * @param {IQueryOperatorType} [firstTimeOperator]
     * @param {string} [secondTimeValue] Query by TimeStamp and apply SecondTimeOperator. For example TimeStamp &lt;&#x3D; 2022-12-01.
     * @param {IQueryOperatorType} [secondTimeOperator]
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementNotesGet(
      elementId?: string,
      firstTimeValue?: string,
      firstTimeOperator?: IQueryOperatorType,
      secondTimeValue?: string,
      secondTimeOperator?: IQueryOperatorType,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IElementNoteListIRadianseResultSuccess> {
      return localVarFp
        .userApiElementNotesGet(
          elementId,
          firstTimeValue,
          firstTimeOperator,
          secondTimeValue,
          secondTimeOperator,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ElementNoteApi - object-oriented interface
 * @export
 * @class ElementNoteApi
 * @extends {BaseAPI}
 */
export class ElementNoteApi extends BaseAPI {
  /**
   * Permission: elementnotes_read
   * @summary Get all ElementNotes
   * @param {string} [elementId] The element id associated with the notes. This would be equipment id for equipment.
   * @param {string} [firstTimeValue] Query by TimeStamp and apply firstTimeOperator. For example TimeStamp &gt;&#x3D; 2022-11-01.
   * @param {IQueryOperatorType} [firstTimeOperator]
   * @param {string} [secondTimeValue] Query by TimeStamp and apply SecondTimeOperator. For example TimeStamp &lt;&#x3D; 2022-12-01.
   * @param {IQueryOperatorType} [secondTimeOperator]
   * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementNoteApi
   */
  public userApiElementNotesGet(
    elementId?: string,
    firstTimeValue?: string,
    firstTimeOperator?: IQueryOperatorType,
    secondTimeValue?: string,
    secondTimeOperator?: IQueryOperatorType,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementNoteApiFp(this.configuration)
      .userApiElementNotesGet(
        elementId,
        firstTimeValue,
        firstTimeOperator,
        secondTimeValue,
        secondTimeOperator,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ElementTreeApi - axios parameter creator
 * @export
 */
export const ElementTreeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: elementtree_delete
     * @summary Delete a child. If child has children, do not allow. The children will have to get  deleted first.
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeChildIdDelete: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiElementTreeChildIdDelete", "id", id);
      const localVarPath = `/UserApi/ElementTree/Child/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtree_read
     * @summary Get element tree child by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeChildIdGet: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiElementTreeChildIdGet", "id", id);
      const localVarPath = `/UserApi/ElementTree/Child/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtree_edit
     * @summary Add a child to the parent element.
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementTreeChildDto} [iElementTreeChildDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeChildIdPut: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementTreeChildDto?: IElementTreeChildDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiElementTreeChildIdPut", "id", id);
      const localVarPath = `/UserApi/ElementTree/Child/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iElementTreeChildDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtree_create
     * @summary Add a child to the parent element. An ID will get generated for the child.
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementTreeChildDto} [iElementTreeChildDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeChildPost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementTreeChildDto?: IElementTreeChildDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ElementTree/Child`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iElementTreeChildDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtree_read
     * @summary Get an element tree as an embedded tree
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeGet: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ElementTree`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtree_read
     * @summary Get an element tree as a flattened list
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeListGet: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ElementTree/List`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ElementTreeApi - functional programming interface
 * @export
 */
export const ElementTreeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ElementTreeApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: elementtree_delete
     * @summary Delete a child. If child has children, do not allow. The children will have to get  deleted first.
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeChildIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IElementTreeIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeChildIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtree_read
     * @summary Get element tree child by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeChildIdGet(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IElementTreeIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeChildIdGet(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtree_edit
     * @summary Add a child to the parent element.
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementTreeChildDto} [iElementTreeChildDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeChildIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementTreeChildDto?: IElementTreeChildDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IElementTreeIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeChildIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementTreeChildDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtree_create
     * @summary Add a child to the parent element. An ID will get generated for the child.
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementTreeChildDto} [iElementTreeChildDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeChildPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementTreeChildDto?: IElementTreeChildDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IElementTreeIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeChildPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementTreeChildDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtree_read
     * @summary Get an element tree as an embedded tree
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IElementTreeTreeItemIEnumerableIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtree_read
     * @summary Get an element tree as a flattened list
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeListGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IElementTreeListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeListGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ElementTreeApi - factory interface
 * @export
 */
export const ElementTreeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ElementTreeApiFp(configuration);
  return {
    /**
     * Permission: elementtree_delete
     * @summary Delete a child. If child has children, do not allow. The children will have to get  deleted first.
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeChildIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IElementTreeIRadianseResultSuccess> {
      return localVarFp
        .userApiElementTreeChildIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtree_read
     * @summary Get element tree child by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeChildIdGet(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IElementTreeIRadianseResultSuccess> {
      return localVarFp
        .userApiElementTreeChildIdGet(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtree_edit
     * @summary Add a child to the parent element.
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementTreeChildDto} [iElementTreeChildDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeChildIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementTreeChildDto?: IElementTreeChildDto,
      options?: any
    ): AxiosPromise<IElementTreeIRadianseResultSuccess> {
      return localVarFp
        .userApiElementTreeChildIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementTreeChildDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtree_create
     * @summary Add a child to the parent element. An ID will get generated for the child.
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementTreeChildDto} [iElementTreeChildDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeChildPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementTreeChildDto?: IElementTreeChildDto,
      options?: any
    ): AxiosPromise<IElementTreeIRadianseResultSuccess> {
      return localVarFp
        .userApiElementTreeChildPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementTreeChildDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtree_read
     * @summary Get an element tree as an embedded tree
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IElementTreeTreeItemIEnumerableIRadianseResultSuccess> {
      return localVarFp
        .userApiElementTreeGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtree_read
     * @summary Get an element tree as a flattened list
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeListGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IElementTreeListIRadianseResultSuccess> {
      return localVarFp
        .userApiElementTreeListGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ElementTreeApi - object-oriented interface
 * @export
 * @class ElementTreeApi
 * @extends {BaseAPI}
 */
export class ElementTreeApi extends BaseAPI {
  /**
   * Permission: elementtree_delete
   * @summary Delete a child. If child has children, do not allow. The children will have to get  deleted first.
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeApi
   */
  public userApiElementTreeChildIdDelete(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeApiFp(this.configuration)
      .userApiElementTreeChildIdDelete(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtree_read
   * @summary Get element tree child by id
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeApi
   */
  public userApiElementTreeChildIdGet(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeApiFp(this.configuration)
      .userApiElementTreeChildIdGet(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtree_edit
   * @summary Add a child to the parent element.
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IElementTreeChildDto} [iElementTreeChildDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeApi
   */
  public userApiElementTreeChildIdPut(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iElementTreeChildDto?: IElementTreeChildDto,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeApiFp(this.configuration)
      .userApiElementTreeChildIdPut(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iElementTreeChildDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtree_create
   * @summary Add a child to the parent element. An ID will get generated for the child.
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IElementTreeChildDto} [iElementTreeChildDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeApi
   */
  public userApiElementTreeChildPost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iElementTreeChildDto?: IElementTreeChildDto,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeApiFp(this.configuration)
      .userApiElementTreeChildPost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iElementTreeChildDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtree_read
   * @summary Get an element tree as an embedded tree
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeApi
   */
  public userApiElementTreeGet(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeApiFp(this.configuration)
      .userApiElementTreeGet(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtree_read
   * @summary Get an element tree as a flattened list
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeApi
   */
  public userApiElementTreeListGet(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeApiFp(this.configuration)
      .userApiElementTreeListGet(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EquipmentApi - axios parameter creator
 * @export
 */
export const EquipmentApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: equipment_read                If equipment is RADIANASEWIFI, the device id is in the attached ids. If equipment is TMAX, the device id is in the index.
     * @summary Get equipment by device id and connector id
     * @param {string} deviceId The device to look for
     * @param {string} connectorId The connector the device belongs to. Example: RADIANSEWIFI or TMAX
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentDeviceIdConnectorIdGet: async (
      deviceId: string,
      connectorId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceId' is not null or undefined
      assertParamExists(
        "userApiEquipmentDeviceIdConnectorIdGet",
        "deviceId",
        deviceId
      );
      // verify required parameter 'connectorId' is not null or undefined
      assertParamExists(
        "userApiEquipmentDeviceIdConnectorIdGet",
        "connectorId",
        connectorId
      );
      const localVarPath = `/UserApi/Equipment/{deviceId}/{connectorId}`
        .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
        .replace(`{${"connectorId"}}`, encodeURIComponent(String(connectorId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipment_read
     * @summary Get all equipment
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {string} [eventsId] Get all equipment that belongs to an events
     * @param {boolean} [deleted]
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentGet: async (
      clientTreeType?: IClientTreeType,
      eventsId?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Equipment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (eventsId !== undefined) {
        localVarQueryParameter["eventsId"] = eventsId;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipment_delete
     * @summary Delete equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentIdDelete: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEquipmentIdDelete", "id", id);
      const localVarPath = `/UserApi/Equipment/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipment_read
     * @summary Get equipment by id
     * @param {string} id
     * @param {boolean} [forceReread] Get from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentIdGet: async (
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEquipmentIdGet", "id", id);
      const localVarPath = `/UserApi/Equipment/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (forceReread !== undefined) {
        localVarQueryParameter["forceReread"] = forceReread;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipment_create
     * @summary Patch equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentPatchDto} [iEquipmentPatchDto] If the purpose is to remove connectors, set the first connector\&#39;s id to \&quot;null\&quot;. Set eventsId to \&quot;null\&quot; to remove eventsId.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentIdPatch: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentPatchDto?: IEquipmentPatchDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEquipmentIdPatch", "id", id);
      const localVarPath = `/UserApi/Equipment/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEquipmentPatchDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipment_create
     * @summary Create or edit equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDto} [iEquipmentDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentIdPut: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDto?: IEquipmentDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEquipmentIdPut", "id", id);
      const localVarPath = `/UserApi/Equipment/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEquipmentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipment_create
     * @summary Create equipment
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDto} [iEquipmentDto] Equipment to create. Equipment.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentPost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDto?: IEquipmentDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Equipment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEquipmentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EquipmentApi - functional programming interface
 * @export
 */
export const EquipmentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EquipmentApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: equipment_read                If equipment is RADIANASEWIFI, the device id is in the attached ids. If equipment is TMAX, the device id is in the index.
     * @summary Get equipment by device id and connector id
     * @param {string} deviceId The device to look for
     * @param {string} connectorId The connector the device belongs to. Example: RADIANSEWIFI or TMAX
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentDeviceIdConnectorIdGet(
      deviceId: string,
      connectorId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentDeviceIdConnectorIdGet(
          deviceId,
          connectorId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipment_read
     * @summary Get all equipment
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {string} [eventsId] Get all equipment that belongs to an events
     * @param {boolean} [deleted]
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentGet(
      clientTreeType?: IClientTreeType,
      eventsId?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentGet(
          clientTreeType,
          eventsId,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipment_delete
     * @summary Delete equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipment_read
     * @summary Get equipment by id
     * @param {string} id
     * @param {boolean} [forceReread] Get from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentIdGet(
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentIdGet(
          id,
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipment_create
     * @summary Patch equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentPatchDto} [iEquipmentPatchDto] If the purpose is to remove connectors, set the first connector\&#39;s id to \&quot;null\&quot;. Set eventsId to \&quot;null\&quot; to remove eventsId.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentIdPatch(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentPatchDto?: IEquipmentPatchDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentIdPatch(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentPatchDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipment_create
     * @summary Create or edit equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDto} [iEquipmentDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDto?: IEquipmentDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipment_create
     * @summary Create equipment
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDto} [iEquipmentDto] Equipment to create. Equipment.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDto?: IEquipmentDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * EquipmentApi - factory interface
 * @export
 */
export const EquipmentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EquipmentApiFp(configuration);
  return {
    /**
     * Permission: equipment_read                If equipment is RADIANASEWIFI, the device id is in the attached ids. If equipment is TMAX, the device id is in the index.
     * @summary Get equipment by device id and connector id
     * @param {string} deviceId The device to look for
     * @param {string} connectorId The connector the device belongs to. Example: RADIANSEWIFI or TMAX
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentDeviceIdConnectorIdGet(
      deviceId: string,
      connectorId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIEquipmentIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentDeviceIdConnectorIdGet(
          deviceId,
          connectorId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipment_read
     * @summary Get all equipment
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {string} [eventsId] Get all equipment that belongs to an events
     * @param {boolean} [deleted]
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentGet(
      clientTreeType?: IClientTreeType,
      eventsId?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIEquipmentListIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentGet(
          clientTreeType,
          eventsId,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipment_delete
     * @summary Delete equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIEquipmentIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipment_read
     * @summary Get equipment by id
     * @param {string} id
     * @param {boolean} [forceReread] Get from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentIdGet(
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIEquipmentIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentIdGet(
          id,
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipment_create
     * @summary Patch equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentPatchDto} [iEquipmentPatchDto] If the purpose is to remove connectors, set the first connector\&#39;s id to \&quot;null\&quot;. Set eventsId to \&quot;null\&quot; to remove eventsId.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentIdPatch(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentPatchDto?: IEquipmentPatchDto,
      options?: any
    ): AxiosPromise<IIEquipmentIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentIdPatch(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentPatchDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipment_create
     * @summary Create or edit equipment
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDto} [iEquipmentDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDto?: IEquipmentDto,
      options?: any
    ): AxiosPromise<IIEquipmentIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipment_create
     * @summary Create equipment
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDto} [iEquipmentDto] Equipment to create. Equipment.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDto?: IEquipmentDto,
      options?: any
    ): AxiosPromise<IIEquipmentIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EquipmentApi - object-oriented interface
 * @export
 * @class EquipmentApi
 * @extends {BaseAPI}
 */
export class EquipmentApi extends BaseAPI {
  /**
   * Permission: equipment_read                If equipment is RADIANASEWIFI, the device id is in the attached ids. If equipment is TMAX, the device id is in the index.
   * @summary Get equipment by device id and connector id
   * @param {string} deviceId The device to look for
   * @param {string} connectorId The connector the device belongs to. Example: RADIANSEWIFI or TMAX
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentApi
   */
  public userApiEquipmentDeviceIdConnectorIdGet(
    deviceId: string,
    connectorId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentApiFp(this.configuration)
      .userApiEquipmentDeviceIdConnectorIdGet(
        deviceId,
        connectorId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipment_read
   * @summary Get all equipment
   * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
   * @param {string} [eventsId] Get all equipment that belongs to an events
   * @param {boolean} [deleted]
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentApi
   */
  public userApiEquipmentGet(
    clientTreeType?: IClientTreeType,
    eventsId?: string,
    deleted?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentApiFp(this.configuration)
      .userApiEquipmentGet(
        clientTreeType,
        eventsId,
        deleted,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipment_delete
   * @summary Delete equipment
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentApi
   */
  public userApiEquipmentIdDelete(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentApiFp(this.configuration)
      .userApiEquipmentIdDelete(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipment_read
   * @summary Get equipment by id
   * @param {string} id
   * @param {boolean} [forceReread] Get from cache or database. Defaults to read from database
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentApi
   */
  public userApiEquipmentIdGet(
    id: string,
    forceReread?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentApiFp(this.configuration)
      .userApiEquipmentIdGet(
        id,
        forceReread,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipment_create
   * @summary Patch equipment
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEquipmentPatchDto} [iEquipmentPatchDto] If the purpose is to remove connectors, set the first connector\&#39;s id to \&quot;null\&quot;. Set eventsId to \&quot;null\&quot; to remove eventsId.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentApi
   */
  public userApiEquipmentIdPatch(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEquipmentPatchDto?: IEquipmentPatchDto,
    options?: AxiosRequestConfig
  ) {
    return EquipmentApiFp(this.configuration)
      .userApiEquipmentIdPatch(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iEquipmentPatchDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipment_create
   * @summary Create or edit equipment
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEquipmentDto} [iEquipmentDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentApi
   */
  public userApiEquipmentIdPut(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEquipmentDto?: IEquipmentDto,
    options?: AxiosRequestConfig
  ) {
    return EquipmentApiFp(this.configuration)
      .userApiEquipmentIdPut(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iEquipmentDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipment_create
   * @summary Create equipment
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEquipmentDto} [iEquipmentDto] Equipment to create. Equipment.Id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentApi
   */
  public userApiEquipmentPost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEquipmentDto?: IEquipmentDto,
    options?: AxiosRequestConfig
  ) {
    return EquipmentApiFp(this.configuration)
      .userApiEquipmentPost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iEquipmentDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: events_read
     * @summary Get all events
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null defaults to Tenant.
     * @param {string} [elementTreeId] Optional filter by elementTree contains elementTreeId
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsGet: async (
      clientTreeType?: IClientTreeType,
      elementTreeId?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Events`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (elementTreeId !== undefined) {
        localVarQueryParameter["elementTreeId"] = elementTreeId;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: events_delete
     * @summary Delete events
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsIdDelete: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEventsIdDelete", "id", id);
      const localVarPath = `/UserApi/Events/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: events_read
     * @summary Get events by id
     * @param {string} id
     * @param {boolean} [forceReread] Get from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsIdGet: async (
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEventsIdGet", "id", id);
      const localVarPath = `/UserApi/Events/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (forceReread !== undefined) {
        localVarQueryParameter["forceReread"] = forceReread;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: events_create
     * @summary Patch events
     * @param {string} id
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  Also, equipment that may have had eventsId with this same value and  not include in the equipmentIds will have the eventsId removed from the equipment.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;&#x3D;[\&quot;null\&quot;])  Example:0007d1b8-862b-4179-90e5-c7c2951adf2a, 8844853b-9a62-4b7d-b9b4-ece1acbc84f4, c7625cc2-709e-4992-8c5c-c935bb66234d, 0007d1b8-862b-4179-90e5-c7c2951adf2a
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsPatchDto} [iEventsPatchDto] Setting NULL: API does not know whether to set to null or simply not set the param (leave as original value) when a parameter is set to null.  To set the RecurringCron to null, set it to a value of empty string \&quot;\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsIdPatch: async (
      id: string,
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsPatchDto?: IEventsPatchDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEventsIdPatch", "id", id);
      const localVarPath = `/UserApi/Events/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (equipmentIds) {
        localVarQueryParameter["equipmentIds"] = equipmentIds;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEventsPatchDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: events_create
     * @summary Create or edit events
     * @param {string} id
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  Also, equipment that may have had eventsId with this same value and  not include in the equipmentIds will have the eventsId removed from the equipment.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;&#x3D;[\&quot;null\&quot;]), if slots has a value then keep that value.  Example:0007d1b8-862b-4179-90e5-c7c2951adf2a, 8844853b-9a62-4b7d-b9b4-ece1acbc84f4, c7625cc2-709e-4992-8c5c-c935bb66234d, 0007d1b8-862b-4179-90e5-c7c2951adf2a
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsDto} [iEventsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsIdPut: async (
      id: string,
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsDto?: IEventsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEventsIdPut", "id", id);
      const localVarPath = `/UserApi/Events/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (equipmentIds) {
        localVarQueryParameter["equipmentIds"] = equipmentIds;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEventsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: events_create
     * @summary Create events
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;[\&quot;null\&quot;])
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsDto} [iEventsDto] Events to create. Events.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsPost: async (
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsDto?: IEventsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Events`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (equipmentIds) {
        localVarQueryParameter["equipmentIds"] = equipmentIds;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEventsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: events_read
     * @summary Get all events
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null defaults to Tenant.
     * @param {string} [elementTreeId] Optional filter by elementTree contains elementTreeId
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEventsGet(
      clientTreeType?: IClientTreeType,
      elementTreeId?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEventsListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsGet(
          clientTreeType,
          elementTreeId,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: events_delete
     * @summary Delete events
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEventsIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEventsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: events_read
     * @summary Get events by id
     * @param {string} id
     * @param {boolean} [forceReread] Get from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEventsIdGet(
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEventsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsIdGet(
          id,
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: events_create
     * @summary Patch events
     * @param {string} id
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  Also, equipment that may have had eventsId with this same value and  not include in the equipmentIds will have the eventsId removed from the equipment.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;&#x3D;[\&quot;null\&quot;])  Example:0007d1b8-862b-4179-90e5-c7c2951adf2a, 8844853b-9a62-4b7d-b9b4-ece1acbc84f4, c7625cc2-709e-4992-8c5c-c935bb66234d, 0007d1b8-862b-4179-90e5-c7c2951adf2a
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsPatchDto} [iEventsPatchDto] Setting NULL: API does not know whether to set to null or simply not set the param (leave as original value) when a parameter is set to null.  To set the RecurringCron to null, set it to a value of empty string \&quot;\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEventsIdPatch(
      id: string,
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsPatchDto?: IEventsPatchDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEquipmentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsIdPatch(
          id,
          equipmentIds,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEventsPatchDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: events_create
     * @summary Create or edit events
     * @param {string} id
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  Also, equipment that may have had eventsId with this same value and  not include in the equipmentIds will have the eventsId removed from the equipment.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;&#x3D;[\&quot;null\&quot;]), if slots has a value then keep that value.  Example:0007d1b8-862b-4179-90e5-c7c2951adf2a, 8844853b-9a62-4b7d-b9b4-ece1acbc84f4, c7625cc2-709e-4992-8c5c-c935bb66234d, 0007d1b8-862b-4179-90e5-c7c2951adf2a
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsDto} [iEventsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEventsIdPut(
      id: string,
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsDto?: IEventsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEventsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsIdPut(
          id,
          equipmentIds,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEventsDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: events_create
     * @summary Create events
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;[\&quot;null\&quot;])
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsDto} [iEventsDto] Events to create. Events.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEventsPost(
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsDto?: IEventsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIEventsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsPost(
          equipmentIds,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEventsDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EventsApiFp(configuration);
  return {
    /**
     * Permission: events_read
     * @summary Get all events
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null defaults to Tenant.
     * @param {string} [elementTreeId] Optional filter by elementTree contains elementTreeId
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsGet(
      clientTreeType?: IClientTreeType,
      elementTreeId?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIEventsListIRadianseResultSuccess> {
      return localVarFp
        .userApiEventsGet(
          clientTreeType,
          elementTreeId,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: events_delete
     * @summary Delete events
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIEventsIRadianseResultSuccess> {
      return localVarFp
        .userApiEventsIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: events_read
     * @summary Get events by id
     * @param {string} id
     * @param {boolean} [forceReread] Get from cache or database. Defaults to read from database
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsIdGet(
      id: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIEventsIRadianseResultSuccess> {
      return localVarFp
        .userApiEventsIdGet(
          id,
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: events_create
     * @summary Patch events
     * @param {string} id
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  Also, equipment that may have had eventsId with this same value and  not include in the equipmentIds will have the eventsId removed from the equipment.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;&#x3D;[\&quot;null\&quot;])  Example:0007d1b8-862b-4179-90e5-c7c2951adf2a, 8844853b-9a62-4b7d-b9b4-ece1acbc84f4, c7625cc2-709e-4992-8c5c-c935bb66234d, 0007d1b8-862b-4179-90e5-c7c2951adf2a
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsPatchDto} [iEventsPatchDto] Setting NULL: API does not know whether to set to null or simply not set the param (leave as original value) when a parameter is set to null.  To set the RecurringCron to null, set it to a value of empty string \&quot;\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsIdPatch(
      id: string,
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsPatchDto?: IEventsPatchDto,
      options?: any
    ): AxiosPromise<IIEquipmentIRadianseResultSuccess> {
      return localVarFp
        .userApiEventsIdPatch(
          id,
          equipmentIds,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEventsPatchDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: events_create
     * @summary Create or edit events
     * @param {string} id
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  Also, equipment that may have had eventsId with this same value and  not include in the equipmentIds will have the eventsId removed from the equipment.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;&#x3D;[\&quot;null\&quot;]), if slots has a value then keep that value.  Example:0007d1b8-862b-4179-90e5-c7c2951adf2a, 8844853b-9a62-4b7d-b9b4-ece1acbc84f4, c7625cc2-709e-4992-8c5c-c935bb66234d, 0007d1b8-862b-4179-90e5-c7c2951adf2a
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsDto} [iEventsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsIdPut(
      id: string,
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsDto?: IEventsDto,
      options?: any
    ): AxiosPromise<IIEventsIRadianseResultSuccess> {
      return localVarFp
        .userApiEventsIdPut(
          id,
          equipmentIds,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEventsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: events_create
     * @summary Create events
     * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;[\&quot;null\&quot;])
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEventsDto} [iEventsDto] Events to create. Events.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsPost(
      equipmentIds?: Array<string>,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEventsDto?: IEventsDto,
      options?: any
    ): AxiosPromise<IIEventsIRadianseResultSuccess> {
      return localVarFp
        .userApiEventsPost(
          equipmentIds,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iEventsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
  /**
   * Permission: events_read
   * @summary Get all events
   * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null defaults to Tenant.
   * @param {string} [elementTreeId] Optional filter by elementTree contains elementTreeId
   * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public userApiEventsGet(
    clientTreeType?: IClientTreeType,
    elementTreeId?: string,
    deleted?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .userApiEventsGet(
        clientTreeType,
        elementTreeId,
        deleted,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: events_delete
   * @summary Delete events
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public userApiEventsIdDelete(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .userApiEventsIdDelete(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: events_read
   * @summary Get events by id
   * @param {string} id
   * @param {boolean} [forceReread] Get from cache or database. Defaults to read from database
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public userApiEventsIdGet(
    id: string,
    forceReread?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .userApiEventsIdGet(
        id,
        forceReread,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: events_create
   * @summary Patch events
   * @param {string} id
   * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  Also, equipment that may have had eventsId with this same value and  not include in the equipmentIds will have the eventsId removed from the equipment.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;&#x3D;[\&quot;null\&quot;])  Example:0007d1b8-862b-4179-90e5-c7c2951adf2a, 8844853b-9a62-4b7d-b9b4-ece1acbc84f4, c7625cc2-709e-4992-8c5c-c935bb66234d, 0007d1b8-862b-4179-90e5-c7c2951adf2a
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEventsPatchDto} [iEventsPatchDto] Setting NULL: API does not know whether to set to null or simply not set the param (leave as original value) when a parameter is set to null.  To set the RecurringCron to null, set it to a value of empty string \&quot;\&quot;.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public userApiEventsIdPatch(
    id: string,
    equipmentIds?: Array<string>,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEventsPatchDto?: IEventsPatchDto,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .userApiEventsIdPatch(
        id,
        equipmentIds,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iEventsPatchDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: events_create
   * @summary Create or edit events
   * @param {string} id
   * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  Also, equipment that may have had eventsId with this same value and  not include in the equipmentIds will have the eventsId removed from the equipment.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;&#x3D;[\&quot;null\&quot;]), if slots has a value then keep that value.  Example:0007d1b8-862b-4179-90e5-c7c2951adf2a, 8844853b-9a62-4b7d-b9b4-ece1acbc84f4, c7625cc2-709e-4992-8c5c-c935bb66234d, 0007d1b8-862b-4179-90e5-c7c2951adf2a
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEventsDto} [iEventsDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public userApiEventsIdPut(
    id: string,
    equipmentIds?: Array<string>,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEventsDto?: IEventsDto,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .userApiEventsIdPut(
        id,
        equipmentIds,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iEventsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: events_create
   * @summary Create events
   * @param {Array<string>} [equipmentIds] If included, events.slots will be set to the equipmentIds.Count and  each piece of equipment will get updated to set Equipment.EventsId.  If not include events.slots will use the value passed in.  If equipmentIds contains one id with value \&quot;null\&quot;, all equipment will be removed from the events, (send query param ?equipmentIds&#x3D;[\&quot;null\&quot;])
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEventsDto} [iEventsDto] Events to create. Events.Id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public userApiEventsPost(
    equipmentIds?: Array<string>,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEventsDto?: IEventsDto,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .userApiEventsPost(
        equipmentIds,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iEventsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ImagesApi - axios parameter creator
 * @export
 */
export const ImagesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: images_read
     * @summary Get image by id
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, the original image will be returned.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImagesEncodedIdGet: async (
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiImagesEncodedIdGet", "id", id);
      const localVarPath = `/UserApi/Images/encoded/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (imageSizeType !== undefined) {
        localVarQueryParameter["imageSizeType"] = imageSizeType;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: images_delete
     * @summary Delete image
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, delete all images sizes
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImagesIdDelete: async (
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiImagesIdDelete", "id", id);
      const localVarPath = `/UserApi/Images/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (imageSizeType !== undefined) {
        localVarQueryParameter["imageSizeType"] = imageSizeType;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: images_read
     * @summary Get image by id
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, the original image will be returned.
     * @param {string} [groupId] GroupId is required if using a bearer token
     * @param {string} [tenantId] TenantId is required if using a bearer token
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImagesIdGet: async (
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiImagesIdGet", "id", id);
      const localVarPath = `/UserApi/Images/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (imageSizeType !== undefined) {
        localVarQueryParameter["imageSizeType"] = imageSizeType;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: images_create
     * @summary Create image
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] Caller indicates the size of the image
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDataUrlDto} [iDataUrlDto] Must be in the format of RFC2397 data:[mediatype][;base64] [encoded image].
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImagesIdPut: async (
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDataUrlDto?: IDataUrlDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiImagesIdPut", "id", id);
      const localVarPath = `/UserApi/Images/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (imageSizeType !== undefined) {
        localVarQueryParameter["imageSizeType"] = imageSizeType;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iDataUrlDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ImagesApi - functional programming interface
 * @export
 */
export const ImagesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ImagesApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: images_read
     * @summary Get image by id
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, the original image will be returned.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImagesEncodedIdGet(
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImagesEncodedIdGet(
          id,
          imageSizeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: images_delete
     * @summary Delete image
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, delete all images sizes
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImagesIdDelete(
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImagesIdDelete(
          id,
          imageSizeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: images_read
     * @summary Get image by id
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, the original image will be returned.
     * @param {string} [groupId] GroupId is required if using a bearer token
     * @param {string} [tenantId] TenantId is required if using a bearer token
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImagesIdGet(
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImagesIdGet(
          id,
          imageSizeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: images_create
     * @summary Create image
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] Caller indicates the size of the image
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDataUrlDto} [iDataUrlDto] Must be in the format of RFC2397 data:[mediatype][;base64] [encoded image].
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImagesIdPut(
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDataUrlDto?: IDataUrlDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImagesIdPut(
          id,
          imageSizeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iDataUrlDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ImagesApi - factory interface
 * @export
 */
export const ImagesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ImagesApiFp(configuration);
  return {
    /**
     * Permission: images_read
     * @summary Get image by id
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, the original image will be returned.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImagesEncodedIdGet(
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .userApiImagesEncodedIdGet(
          id,
          imageSizeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: images_delete
     * @summary Delete image
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, delete all images sizes
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImagesIdDelete(
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .userApiImagesIdDelete(
          id,
          imageSizeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: images_read
     * @summary Get image by id
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] If null, the original image will be returned.
     * @param {string} [groupId] GroupId is required if using a bearer token
     * @param {string} [tenantId] TenantId is required if using a bearer token
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImagesIdGet(
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .userApiImagesIdGet(
          id,
          imageSizeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: images_create
     * @summary Create image
     * @param {string} id
     * @param {IImageSizeType} [imageSizeType] Caller indicates the size of the image
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDataUrlDto} [iDataUrlDto] Must be in the format of RFC2397 data:[mediatype][;base64] [encoded image].
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImagesIdPut(
      id: string,
      imageSizeType?: IImageSizeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDataUrlDto?: IDataUrlDto,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .userApiImagesIdPut(
          id,
          imageSizeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iDataUrlDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ImagesApi - object-oriented interface
 * @export
 * @class ImagesApi
 * @extends {BaseAPI}
 */
export class ImagesApi extends BaseAPI {
  /**
   * Permission: images_read
   * @summary Get image by id
   * @param {string} id
   * @param {IImageSizeType} [imageSizeType] If null, the original image will be returned.
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImagesApi
   */
  public userApiImagesEncodedIdGet(
    id: string,
    imageSizeType?: IImageSizeType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImagesApiFp(this.configuration)
      .userApiImagesEncodedIdGet(
        id,
        imageSizeType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: images_delete
   * @summary Delete image
   * @param {string} id
   * @param {IImageSizeType} [imageSizeType] If null, delete all images sizes
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImagesApi
   */
  public userApiImagesIdDelete(
    id: string,
    imageSizeType?: IImageSizeType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImagesApiFp(this.configuration)
      .userApiImagesIdDelete(
        id,
        imageSizeType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: images_read
   * @summary Get image by id
   * @param {string} id
   * @param {IImageSizeType} [imageSizeType] If null, the original image will be returned.
   * @param {string} [groupId] GroupId is required if using a bearer token
   * @param {string} [tenantId] TenantId is required if using a bearer token
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImagesApi
   */
  public userApiImagesIdGet(
    id: string,
    imageSizeType?: IImageSizeType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImagesApiFp(this.configuration)
      .userApiImagesIdGet(
        id,
        imageSizeType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: images_create
   * @summary Create image
   * @param {string} id
   * @param {IImageSizeType} [imageSizeType] Caller indicates the size of the image
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IDataUrlDto} [iDataUrlDto] Must be in the format of RFC2397 data:[mediatype][;base64] [encoded image].
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImagesApi
   */
  public userApiImagesIdPut(
    id: string,
    imageSizeType?: IImageSizeType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iDataUrlDto?: IDataUrlDto,
    options?: AxiosRequestConfig
  ) {
    return ImagesApiFp(this.configuration)
      .userApiImagesIdPut(
        id,
        imageSizeType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iDataUrlDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * LanguageApi - axios parameter creator
 * @export
 */
export const LanguageApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: language_read
     * @summary Get Language
     * @param {string} language
     * @param {string} subCategory
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiLanguageLanguageSubCategoryGet: async (
      language: string,
      subCategory: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists(
        "userApiLanguageLanguageSubCategoryGet",
        "language",
        language
      );
      // verify required parameter 'subCategory' is not null or undefined
      assertParamExists(
        "userApiLanguageLanguageSubCategoryGet",
        "subCategory",
        subCategory
      );
      const localVarPath = `/UserApi/Language/{language}/{subCategory}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"subCategory"}}`, encodeURIComponent(String(subCategory)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: language_create
     * @summary Create or edit Language
     * @param {string} language
     * @param {string} subCategory
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {{ [key: string]: string; }} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiLanguageLanguageSubCategoryPut: async (
      language: string,
      subCategory: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      requestBody?: { [key: string]: string },
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'language' is not null or undefined
      assertParamExists(
        "userApiLanguageLanguageSubCategoryPut",
        "language",
        language
      );
      // verify required parameter 'subCategory' is not null or undefined
      assertParamExists(
        "userApiLanguageLanguageSubCategoryPut",
        "subCategory",
        subCategory
      );
      const localVarPath = `/UserApi/Language/{language}/{subCategory}`
        .replace(`{${"language"}}`, encodeURIComponent(String(language)))
        .replace(`{${"subCategory"}}`, encodeURIComponent(String(subCategory)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LanguageApi - functional programming interface
 * @export
 */
export const LanguageApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LanguageApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: language_read
     * @summary Get Language
     * @param {string} language
     * @param {string} subCategory
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiLanguageLanguageSubCategoryGet(
      language: string,
      subCategory: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ILanguageIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiLanguageLanguageSubCategoryGet(
          language,
          subCategory,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: language_create
     * @summary Create or edit Language
     * @param {string} language
     * @param {string} subCategory
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {{ [key: string]: string; }} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiLanguageLanguageSubCategoryPut(
      language: string,
      subCategory: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      requestBody?: { [key: string]: string },
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ILanguageIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiLanguageLanguageSubCategoryPut(
          language,
          subCategory,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          requestBody,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * LanguageApi - factory interface
 * @export
 */
export const LanguageApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = LanguageApiFp(configuration);
  return {
    /**
     * Permission: language_read
     * @summary Get Language
     * @param {string} language
     * @param {string} subCategory
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiLanguageLanguageSubCategoryGet(
      language: string,
      subCategory: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ILanguageIRadianseResultSuccess> {
      return localVarFp
        .userApiLanguageLanguageSubCategoryGet(
          language,
          subCategory,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: language_create
     * @summary Create or edit Language
     * @param {string} language
     * @param {string} subCategory
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {{ [key: string]: string; }} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiLanguageLanguageSubCategoryPut(
      language: string,
      subCategory: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      requestBody?: { [key: string]: string },
      options?: any
    ): AxiosPromise<ILanguageIRadianseResultSuccess> {
      return localVarFp
        .userApiLanguageLanguageSubCategoryPut(
          language,
          subCategory,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          requestBody,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * LanguageApi - object-oriented interface
 * @export
 * @class LanguageApi
 * @extends {BaseAPI}
 */
export class LanguageApi extends BaseAPI {
  /**
   * Permission: language_read
   * @summary Get Language
   * @param {string} language
   * @param {string} subCategory
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LanguageApi
   */
  public userApiLanguageLanguageSubCategoryGet(
    language: string,
    subCategory: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return LanguageApiFp(this.configuration)
      .userApiLanguageLanguageSubCategoryGet(
        language,
        subCategory,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: language_create
   * @summary Create or edit Language
   * @param {string} language
   * @param {string} subCategory
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {{ [key: string]: string; }} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LanguageApi
   */
  public userApiLanguageLanguageSubCategoryPut(
    language: string,
    subCategory: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    requestBody?: { [key: string]: string },
    options?: AxiosRequestConfig
  ) {
    return LanguageApiFp(this.configuration)
      .userApiLanguageLanguageSubCategoryPut(
        language,
        subCategory,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        requestBody,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MemberApi - axios parameter creator
 * @export
 */
export const MemberApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: member_read                Members are currently partitioned by barcode and scoped to customer
     * @summary Get Member by barCode
     * @param {string} id
     * @param {string} barCode Barcode
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberIdBarCodeGet: async (
      id: string,
      barCode: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiMemberIdBarCodeGet", "id", id);
      // verify required parameter 'barCode' is not null or undefined
      assertParamExists("userApiMemberIdBarCodeGet", "barCode", barCode);
      const localVarPath = `/UserApi/Member/{id}/{barCode}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"barCode"}}`, encodeURIComponent(String(barCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: member_delete
     * @summary Delete Member
     * @param {string} id
     * @param {string} partitionKey Barcode
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberIdPartitionKeyDelete: async (
      id: string,
      partitionKey: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiMemberIdPartitionKeyDelete", "id", id);
      // verify required parameter 'partitionKey' is not null or undefined
      assertParamExists(
        "userApiMemberIdPartitionKeyDelete",
        "partitionKey",
        partitionKey
      );
      const localVarPath = `/UserApi/Member/{id}/{partitionKey}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(
          `{${"partitionKey"}}`,
          encodeURIComponent(String(partitionKey))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: member_edit
     * @summary Create or edit Member
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IMemberDto} [iMemberDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberIdPut: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iMemberDto?: IMemberDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiMemberIdPut", "id", id);
      const localVarPath = `/UserApi/Member/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iMemberDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: member_create
     * @summary Create Member
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IMemberDto} [iMemberDto] Member to create. Member.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberPost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iMemberDto?: IMemberDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Member`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iMemberDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MemberApi - functional programming interface
 * @export
 */
export const MemberApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MemberApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: member_read                Members are currently partitioned by barcode and scoped to customer
     * @summary Get Member by barCode
     * @param {string} id
     * @param {string} barCode Barcode
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiMemberIdBarCodeGet(
      id: string,
      barCode: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIMemberIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiMemberIdBarCodeGet(
          id,
          barCode,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: member_delete
     * @summary Delete Member
     * @param {string} id
     * @param {string} partitionKey Barcode
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiMemberIdPartitionKeyDelete(
      id: string,
      partitionKey: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIMemberIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiMemberIdPartitionKeyDelete(
          id,
          partitionKey,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: member_edit
     * @summary Create or edit Member
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IMemberDto} [iMemberDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiMemberIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iMemberDto?: IMemberDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIMemberIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiMemberIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iMemberDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: member_create
     * @summary Create Member
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IMemberDto} [iMemberDto] Member to create. Member.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiMemberPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iMemberDto?: IMemberDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIMemberIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiMemberPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iMemberDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * MemberApi - factory interface
 * @export
 */
export const MemberApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MemberApiFp(configuration);
  return {
    /**
     * Permission: member_read                Members are currently partitioned by barcode and scoped to customer
     * @summary Get Member by barCode
     * @param {string} id
     * @param {string} barCode Barcode
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberIdBarCodeGet(
      id: string,
      barCode: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIMemberIRadianseResultSuccess> {
      return localVarFp
        .userApiMemberIdBarCodeGet(
          id,
          barCode,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: member_delete
     * @summary Delete Member
     * @param {string} id
     * @param {string} partitionKey Barcode
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberIdPartitionKeyDelete(
      id: string,
      partitionKey: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIMemberIRadianseResultSuccess> {
      return localVarFp
        .userApiMemberIdPartitionKeyDelete(
          id,
          partitionKey,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: member_edit
     * @summary Create or edit Member
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IMemberDto} [iMemberDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iMemberDto?: IMemberDto,
      options?: any
    ): AxiosPromise<IIMemberIRadianseResultSuccess> {
      return localVarFp
        .userApiMemberIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iMemberDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: member_create
     * @summary Create Member
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IMemberDto} [iMemberDto] Member to create. Member.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iMemberDto?: IMemberDto,
      options?: any
    ): AxiosPromise<IIMemberIRadianseResultSuccess> {
      return localVarFp
        .userApiMemberPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iMemberDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MemberApi - object-oriented interface
 * @export
 * @class MemberApi
 * @extends {BaseAPI}
 */
export class MemberApi extends BaseAPI {
  /**
   * Permission: member_read                Members are currently partitioned by barcode and scoped to customer
   * @summary Get Member by barCode
   * @param {string} id
   * @param {string} barCode Barcode
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public userApiMemberIdBarCodeGet(
    id: string,
    barCode: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .userApiMemberIdBarCodeGet(
        id,
        barCode,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: member_delete
   * @summary Delete Member
   * @param {string} id
   * @param {string} partitionKey Barcode
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public userApiMemberIdPartitionKeyDelete(
    id: string,
    partitionKey: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .userApiMemberIdPartitionKeyDelete(
        id,
        partitionKey,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: member_edit
   * @summary Create or edit Member
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IMemberDto} [iMemberDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public userApiMemberIdPut(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iMemberDto?: IMemberDto,
    options?: AxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .userApiMemberIdPut(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iMemberDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: member_create
   * @summary Create Member
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IMemberDto} [iMemberDto] Member to create. Member.Id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public userApiMemberPost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iMemberDto?: IMemberDto,
    options?: AxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .userApiMemberPost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iMemberDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ModelConfigurationApi - axios parameter creator
 * @export
 */
export const ModelConfigurationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: modelconfiguration_read
     * @summary Get all manufacturer/model configurations
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiModelConfigurationGet: async (
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ModelConfiguration`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: modelconfiguration_delete
     * @summary Delete model configuration
     * @param {string} manufacturer
     * @param {string} model
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiModelConfigurationManufacturerModelDelete: async (
      manufacturer: string,
      model: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'manufacturer' is not null or undefined
      assertParamExists(
        "userApiModelConfigurationManufacturerModelDelete",
        "manufacturer",
        manufacturer
      );
      // verify required parameter 'model' is not null or undefined
      assertParamExists(
        "userApiModelConfigurationManufacturerModelDelete",
        "model",
        model
      );
      const localVarPath = `/UserApi/ModelConfiguration/{manufacturer}/{model}`
        .replace(
          `{${"manufacturer"}}`,
          encodeURIComponent(String(manufacturer))
        )
        .replace(`{${"model"}}`, encodeURIComponent(String(model)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: modelconfiguration_read
     * @summary Gets a specific make/model\'s configuration. Optimal query.
     * @param {string} manufacturer
     * @param {string} model
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiModelConfigurationManufacturerModelGet: async (
      manufacturer: string,
      model: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'manufacturer' is not null or undefined
      assertParamExists(
        "userApiModelConfigurationManufacturerModelGet",
        "manufacturer",
        manufacturer
      );
      // verify required parameter 'model' is not null or undefined
      assertParamExists(
        "userApiModelConfigurationManufacturerModelGet",
        "model",
        model
      );
      const localVarPath = `/UserApi/ModelConfiguration/{manufacturer}/{model}`
        .replace(
          `{${"manufacturer"}}`,
          encodeURIComponent(String(manufacturer))
        )
        .replace(`{${"model"}}`, encodeURIComponent(String(model)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: modelconfiguration_create                ModelConfiguration holds configuration information that applies to a manufacturer/model
     * @summary Create a model configuration
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IModelConfigurationDto} [iModelConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiModelConfigurationPut: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iModelConfigurationDto?: IModelConfigurationDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ModelConfiguration`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iModelConfigurationDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ModelConfigurationApi - functional programming interface
 * @export
 */
export const ModelConfigurationApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    ModelConfigurationApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: modelconfiguration_read
     * @summary Get all manufacturer/model configurations
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiModelConfigurationGet(
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IModelConfigurationListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiModelConfigurationGet(
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: modelconfiguration_delete
     * @summary Delete model configuration
     * @param {string} manufacturer
     * @param {string} model
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiModelConfigurationManufacturerModelDelete(
      manufacturer: string,
      model: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IModelConfigurationIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiModelConfigurationManufacturerModelDelete(
          manufacturer,
          model,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: modelconfiguration_read
     * @summary Gets a specific make/model\'s configuration. Optimal query.
     * @param {string} manufacturer
     * @param {string} model
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiModelConfigurationManufacturerModelGet(
      manufacturer: string,
      model: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IModelConfigurationIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiModelConfigurationManufacturerModelGet(
          manufacturer,
          model,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: modelconfiguration_create                ModelConfiguration holds configuration information that applies to a manufacturer/model
     * @summary Create a model configuration
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IModelConfigurationDto} [iModelConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiModelConfigurationPut(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iModelConfigurationDto?: IModelConfigurationDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IModelConfigurationIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiModelConfigurationPut(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iModelConfigurationDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ModelConfigurationApi - factory interface
 * @export
 */
export const ModelConfigurationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ModelConfigurationApiFp(configuration);
  return {
    /**
     * Permission: modelconfiguration_read
     * @summary Get all manufacturer/model configurations
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiModelConfigurationGet(
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IModelConfigurationListIRadianseResultSuccess> {
      return localVarFp
        .userApiModelConfigurationGet(
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: modelconfiguration_delete
     * @summary Delete model configuration
     * @param {string} manufacturer
     * @param {string} model
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiModelConfigurationManufacturerModelDelete(
      manufacturer: string,
      model: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IModelConfigurationIRadianseResultSuccess> {
      return localVarFp
        .userApiModelConfigurationManufacturerModelDelete(
          manufacturer,
          model,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: modelconfiguration_read
     * @summary Gets a specific make/model\'s configuration. Optimal query.
     * @param {string} manufacturer
     * @param {string} model
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiModelConfigurationManufacturerModelGet(
      manufacturer: string,
      model: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IModelConfigurationIRadianseResultSuccess> {
      return localVarFp
        .userApiModelConfigurationManufacturerModelGet(
          manufacturer,
          model,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: modelconfiguration_create                ModelConfiguration holds configuration information that applies to a manufacturer/model
     * @summary Create a model configuration
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IModelConfigurationDto} [iModelConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiModelConfigurationPut(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iModelConfigurationDto?: IModelConfigurationDto,
      options?: any
    ): AxiosPromise<IModelConfigurationIRadianseResultSuccess> {
      return localVarFp
        .userApiModelConfigurationPut(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iModelConfigurationDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ModelConfigurationApi - object-oriented interface
 * @export
 * @class ModelConfigurationApi
 * @extends {BaseAPI}
 */
export class ModelConfigurationApi extends BaseAPI {
  /**
   * Permission: modelconfiguration_read
   * @summary Get all manufacturer/model configurations
   * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModelConfigurationApi
   */
  public userApiModelConfigurationGet(
    deleted?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ModelConfigurationApiFp(this.configuration)
      .userApiModelConfigurationGet(
        deleted,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: modelconfiguration_delete
   * @summary Delete model configuration
   * @param {string} manufacturer
   * @param {string} model
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModelConfigurationApi
   */
  public userApiModelConfigurationManufacturerModelDelete(
    manufacturer: string,
    model: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ModelConfigurationApiFp(this.configuration)
      .userApiModelConfigurationManufacturerModelDelete(
        manufacturer,
        model,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: modelconfiguration_read
   * @summary Gets a specific make/model\'s configuration. Optimal query.
   * @param {string} manufacturer
   * @param {string} model
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModelConfigurationApi
   */
  public userApiModelConfigurationManufacturerModelGet(
    manufacturer: string,
    model: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ModelConfigurationApiFp(this.configuration)
      .userApiModelConfigurationManufacturerModelGet(
        manufacturer,
        model,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: modelconfiguration_create                ModelConfiguration holds configuration information that applies to a manufacturer/model
   * @summary Create a model configuration
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IModelConfigurationDto} [iModelConfigurationDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModelConfigurationApi
   */
  public userApiModelConfigurationPut(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iModelConfigurationDto?: IModelConfigurationDto,
    options?: AxiosRequestConfig
  ) {
    return ModelConfigurationApiFp(this.configuration)
      .userApiModelConfigurationPut(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iModelConfigurationDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ObjectApi - axios parameter creator
 * @export
 */
export const ObjectApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: object_read                Note, if barcode is also expected to be a partition key (like when searching for members)  then setting passing useAsPartitionKey = true will optimize the search as it will be  performed within one partition only.
     * @summary Searches for a barcode across all kinds of objects in database.
     * @param {string} [barcode]
     * @param {boolean} [useAsPartitionKey] Defaults to true if null.
     * @param {string} [id] ID
     * @param {IImportType} [importType] If object not found, attempts to import from third party. The third party company the object is imported from.
     * @param {string} [accountNumber] If object not found, attempts to import from third party. The account number the object belongs too. For example, a member\&#39;s home clubId.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    barcodeGet: async (
      barcode?: string,
      useAsPartitionKey?: boolean,
      id?: string,
      importType?: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/Barcode`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (barcode !== undefined) {
        localVarQueryParameter["barcode"] = barcode;
      }

      if (useAsPartitionKey !== undefined) {
        localVarQueryParameter["useAsPartitionKey"] = useAsPartitionKey;
      }

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      if (importType !== undefined) {
        localVarQueryParameter["importType"] = importType;
      }

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: object_read                Makes search across all kinds of objects in database. The search is done on And basis  (every keyword should be present in the document). The searched fields are FirstName,  LastName, Barcode, PhoneNumber. The PhoneNumber should be always in a form of  consecutive digits and nothing else (no spaces, no other characters). This format should  be kept both in database and in a search string. TenantId is only used in a query when  it is not null.
     * @summary Makes search across all kinds of objects in database.
     * @param {string} searchString
     * @param {boolean} [includeTenantId]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchSearchStringGet: async (
      searchString: string,
      includeTenantId?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'searchString' is not null or undefined
      assertParamExists("searchSearchStringGet", "searchString", searchString);
      const localVarPath = `/Search/{searchString}`.replace(
        `{${"searchString"}}`,
        encodeURIComponent(String(searchString))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (includeTenantId !== undefined) {
        localVarQueryParameter["includeTenantId"] = includeTenantId;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: object_read                Returns one JObject. The count return is the number of parameters since JObject inherits from ICollection.
     * @summary Get object by id and partition key
     * @param {string} id
     * @param {string} partitionKey
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiObjectIdIdPartitionKeyPartitionKeyGet: async (
      id: string,
      partitionKey: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiObjectIdIdPartitionKeyPartitionKeyGet",
        "id",
        id
      );
      // verify required parameter 'partitionKey' is not null or undefined
      assertParamExists(
        "userApiObjectIdIdPartitionKeyPartitionKeyGet",
        "partitionKey",
        partitionKey
      );
      const localVarPath = `/UserApi/Object/Id/{id}/PartitionKey/{partitionKey}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(
          `{${"partitionKey"}}`,
          encodeURIComponent(String(partitionKey))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * For multiple word search, separate each word with a space. Currently Equipment and Members are supported.  Note: This method is the same as Search/Word and will be obsolete in the future
     * @summary Searches for the specified words. Only entire word is matched. Method does not look inside words or phrases.
     * @param {IClientTreeType} [clientTreeType] Search for all objects within customer, group, or tenant. Defaults to Tenant.                If set to tenant but search will return all object in tenant, if object is of customer scope they will all be returned.
     * @param {string} [searchString]
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 25.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiObjectSearchTextGet: async (
      clientTreeType?: IClientTreeType,
      searchString?: string,
      partitionKey?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Object/Search/Text`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (searchString !== undefined) {
        localVarQueryParameter["searchString"] = searchString;
      }

      if (partitionKey !== undefined) {
        localVarQueryParameter["partitionKey"] = partitionKey;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * For multiple word search, separate each word with a space. Currently Equipment and Members are supported.
     * @summary Searches for the specified words. Only entire word is matched. Method does not look inside words or phrases.
     * @param {IClientTreeType} [clientTreeType] Search for all objects within customer, group, or tenant. Defaults to Tenant.                If set to tenant but search will return all object in tenant, if object is of customer scope they will all be returned.
     * @param {string} [searchString]
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 25.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiObjectSearchWordGet: async (
      clientTreeType?: IClientTreeType,
      searchString?: string,
      partitionKey?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Object/Search/Word`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (searchString !== undefined) {
        localVarQueryParameter["searchString"] = searchString;
      }

      if (partitionKey !== undefined) {
        localVarQueryParameter["partitionKey"] = partitionKey;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Currently Equipment and Members are supported
     * @summary Searches for the specified word. Only entire word is matched. Method does not look inside words or phrases.
     * @param {string} searchString
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiObjectSearchWordSearchStringGet: async (
      searchString: string,
      partitionKey?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'searchString' is not null or undefined
      assertParamExists(
        "userApiObjectSearchWordSearchStringGet",
        "searchString",
        searchString
      );
      const localVarPath = `/UserApi/Object/Search/Word/{searchString}`.replace(
        `{${"searchString"}}`,
        encodeURIComponent(String(searchString))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (partitionKey !== undefined) {
        localVarQueryParameter["partitionKey"] = partitionKey;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ObjectApi - functional programming interface
 * @export
 */
export const ObjectApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ObjectApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: object_read                Note, if barcode is also expected to be a partition key (like when searching for members)  then setting passing useAsPartitionKey = true will optimize the search as it will be  performed within one partition only.
     * @summary Searches for a barcode across all kinds of objects in database.
     * @param {string} [barcode]
     * @param {boolean} [useAsPartitionKey] Defaults to true if null.
     * @param {string} [id] ID
     * @param {IImportType} [importType] If object not found, attempts to import from third party. The third party company the object is imported from.
     * @param {string} [accountNumber] If object not found, attempts to import from third party. The account number the object belongs too. For example, a member\&#39;s home clubId.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async barcodeGet(
      barcode?: string,
      useAsPartitionKey?: boolean,
      id?: string,
      importType?: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IExpandoObjectListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.barcodeGet(
        barcode,
        useAsPartitionKey,
        id,
        importType,
        accountNumber,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: object_read                Makes search across all kinds of objects in database. The search is done on And basis  (every keyword should be present in the document). The searched fields are FirstName,  LastName, Barcode, PhoneNumber. The PhoneNumber should be always in a form of  consecutive digits and nothing else (no spaces, no other characters). This format should  be kept both in database and in a search string. TenantId is only used in a query when  it is not null.
     * @summary Makes search across all kinds of objects in database.
     * @param {string} searchString
     * @param {boolean} [includeTenantId]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchSearchStringGet(
      searchString: string,
      includeTenantId?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IExpandoObjectListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.searchSearchStringGet(
          searchString,
          includeTenantId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: object_read                Returns one JObject. The count return is the number of parameters since JObject inherits from ICollection.
     * @summary Get object by id and partition key
     * @param {string} id
     * @param {string} partitionKey
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiObjectIdIdPartitionKeyPartitionKeyGet(
      id: string,
      partitionKey: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IExpandoObjectIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiObjectIdIdPartitionKeyPartitionKeyGet(
          id,
          partitionKey,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * For multiple word search, separate each word with a space. Currently Equipment and Members are supported.  Note: This method is the same as Search/Word and will be obsolete in the future
     * @summary Searches for the specified words. Only entire word is matched. Method does not look inside words or phrases.
     * @param {IClientTreeType} [clientTreeType] Search for all objects within customer, group, or tenant. Defaults to Tenant.                If set to tenant but search will return all object in tenant, if object is of customer scope they will all be returned.
     * @param {string} [searchString]
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 25.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiObjectSearchTextGet(
      clientTreeType?: IClientTreeType,
      searchString?: string,
      partitionKey?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ISearchListItemListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiObjectSearchTextGet(
          clientTreeType,
          searchString,
          partitionKey,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * For multiple word search, separate each word with a space. Currently Equipment and Members are supported.
     * @summary Searches for the specified words. Only entire word is matched. Method does not look inside words or phrases.
     * @param {IClientTreeType} [clientTreeType] Search for all objects within customer, group, or tenant. Defaults to Tenant.                If set to tenant but search will return all object in tenant, if object is of customer scope they will all be returned.
     * @param {string} [searchString]
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 25.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiObjectSearchWordGet(
      clientTreeType?: IClientTreeType,
      searchString?: string,
      partitionKey?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ISearchListItemListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiObjectSearchWordGet(
          clientTreeType,
          searchString,
          partitionKey,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Currently Equipment and Members are supported
     * @summary Searches for the specified word. Only entire word is matched. Method does not look inside words or phrases.
     * @param {string} searchString
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiObjectSearchWordSearchStringGet(
      searchString: string,
      partitionKey?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ISearchListItemListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiObjectSearchWordSearchStringGet(
          searchString,
          partitionKey,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ObjectApi - factory interface
 * @export
 */
export const ObjectApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ObjectApiFp(configuration);
  return {
    /**
     * Permission: object_read                Note, if barcode is also expected to be a partition key (like when searching for members)  then setting passing useAsPartitionKey = true will optimize the search as it will be  performed within one partition only.
     * @summary Searches for a barcode across all kinds of objects in database.
     * @param {string} [barcode]
     * @param {boolean} [useAsPartitionKey] Defaults to true if null.
     * @param {string} [id] ID
     * @param {IImportType} [importType] If object not found, attempts to import from third party. The third party company the object is imported from.
     * @param {string} [accountNumber] If object not found, attempts to import from third party. The account number the object belongs too. For example, a member\&#39;s home clubId.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    barcodeGet(
      barcode?: string,
      useAsPartitionKey?: boolean,
      id?: string,
      importType?: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IExpandoObjectListIRadianseResultSuccess> {
      return localVarFp
        .barcodeGet(
          barcode,
          useAsPartitionKey,
          id,
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: object_read                Makes search across all kinds of objects in database. The search is done on And basis  (every keyword should be present in the document). The searched fields are FirstName,  LastName, Barcode, PhoneNumber. The PhoneNumber should be always in a form of  consecutive digits and nothing else (no spaces, no other characters). This format should  be kept both in database and in a search string. TenantId is only used in a query when  it is not null.
     * @summary Makes search across all kinds of objects in database.
     * @param {string} searchString
     * @param {boolean} [includeTenantId]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchSearchStringGet(
      searchString: string,
      includeTenantId?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IExpandoObjectListIRadianseResultSuccess> {
      return localVarFp
        .searchSearchStringGet(
          searchString,
          includeTenantId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: object_read                Returns one JObject. The count return is the number of parameters since JObject inherits from ICollection.
     * @summary Get object by id and partition key
     * @param {string} id
     * @param {string} partitionKey
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiObjectIdIdPartitionKeyPartitionKeyGet(
      id: string,
      partitionKey: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IExpandoObjectIRadianseResultSuccess> {
      return localVarFp
        .userApiObjectIdIdPartitionKeyPartitionKeyGet(
          id,
          partitionKey,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * For multiple word search, separate each word with a space. Currently Equipment and Members are supported.  Note: This method is the same as Search/Word and will be obsolete in the future
     * @summary Searches for the specified words. Only entire word is matched. Method does not look inside words or phrases.
     * @param {IClientTreeType} [clientTreeType] Search for all objects within customer, group, or tenant. Defaults to Tenant.                If set to tenant but search will return all object in tenant, if object is of customer scope they will all be returned.
     * @param {string} [searchString]
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 25.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiObjectSearchTextGet(
      clientTreeType?: IClientTreeType,
      searchString?: string,
      partitionKey?: string,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ISearchListItemListIRadianseResultSuccess> {
      return localVarFp
        .userApiObjectSearchTextGet(
          clientTreeType,
          searchString,
          partitionKey,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * For multiple word search, separate each word with a space. Currently Equipment and Members are supported.
     * @summary Searches for the specified words. Only entire word is matched. Method does not look inside words or phrases.
     * @param {IClientTreeType} [clientTreeType] Search for all objects within customer, group, or tenant. Defaults to Tenant.                If set to tenant but search will return all object in tenant, if object is of customer scope they will all be returned.
     * @param {string} [searchString]
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 25.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiObjectSearchWordGet(
      clientTreeType?: IClientTreeType,
      searchString?: string,
      partitionKey?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ISearchListItemListIRadianseResultSuccess> {
      return localVarFp
        .userApiObjectSearchWordGet(
          clientTreeType,
          searchString,
          partitionKey,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Currently Equipment and Members are supported
     * @summary Searches for the specified word. Only entire word is matched. Method does not look inside words or phrases.
     * @param {string} searchString
     * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiObjectSearchWordSearchStringGet(
      searchString: string,
      partitionKey?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ISearchListItemListIRadianseResultSuccess> {
      return localVarFp
        .userApiObjectSearchWordSearchStringGet(
          searchString,
          partitionKey,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ObjectApi - object-oriented interface
 * @export
 * @class ObjectApi
 * @extends {BaseAPI}
 */
export class ObjectApi extends BaseAPI {
  /**
   * Permission: object_read                Note, if barcode is also expected to be a partition key (like when searching for members)  then setting passing useAsPartitionKey = true will optimize the search as it will be  performed within one partition only.
   * @summary Searches for a barcode across all kinds of objects in database.
   * @param {string} [barcode]
   * @param {boolean} [useAsPartitionKey] Defaults to true if null.
   * @param {string} [id] ID
   * @param {IImportType} [importType] If object not found, attempts to import from third party. The third party company the object is imported from.
   * @param {string} [accountNumber] If object not found, attempts to import from third party. The account number the object belongs too. For example, a member\&#39;s home clubId.
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ObjectApi
   */
  public barcodeGet(
    barcode?: string,
    useAsPartitionKey?: boolean,
    id?: string,
    importType?: IImportType,
    accountNumber?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ObjectApiFp(this.configuration)
      .barcodeGet(
        barcode,
        useAsPartitionKey,
        id,
        importType,
        accountNumber,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: object_read                Makes search across all kinds of objects in database. The search is done on And basis  (every keyword should be present in the document). The searched fields are FirstName,  LastName, Barcode, PhoneNumber. The PhoneNumber should be always in a form of  consecutive digits and nothing else (no spaces, no other characters). This format should  be kept both in database and in a search string. TenantId is only used in a query when  it is not null.
   * @summary Makes search across all kinds of objects in database.
   * @param {string} searchString
   * @param {boolean} [includeTenantId]
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ObjectApi
   */
  public searchSearchStringGet(
    searchString: string,
    includeTenantId?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ObjectApiFp(this.configuration)
      .searchSearchStringGet(
        searchString,
        includeTenantId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: object_read                Returns one JObject. The count return is the number of parameters since JObject inherits from ICollection.
   * @summary Get object by id and partition key
   * @param {string} id
   * @param {string} partitionKey
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ObjectApi
   */
  public userApiObjectIdIdPartitionKeyPartitionKeyGet(
    id: string,
    partitionKey: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ObjectApiFp(this.configuration)
      .userApiObjectIdIdPartitionKeyPartitionKeyGet(
        id,
        partitionKey,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * For multiple word search, separate each word with a space. Currently Equipment and Members are supported.  Note: This method is the same as Search/Word and will be obsolete in the future
   * @summary Searches for the specified words. Only entire word is matched. Method does not look inside words or phrases.
   * @param {IClientTreeType} [clientTreeType] Search for all objects within customer, group, or tenant. Defaults to Tenant.                If set to tenant but search will return all object in tenant, if object is of customer scope they will all be returned.
   * @param {string} [searchString]
   * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
   * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
   * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 25.
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof ObjectApi
   */
  public userApiObjectSearchTextGet(
    clientTreeType?: IClientTreeType,
    searchString?: string,
    partitionKey?: string,
    deleted?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ObjectApiFp(this.configuration)
      .userApiObjectSearchTextGet(
        clientTreeType,
        searchString,
        partitionKey,
        deleted,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * For multiple word search, separate each word with a space. Currently Equipment and Members are supported.
   * @summary Searches for the specified words. Only entire word is matched. Method does not look inside words or phrases.
   * @param {IClientTreeType} [clientTreeType] Search for all objects within customer, group, or tenant. Defaults to Tenant.                If set to tenant but search will return all object in tenant, if object is of customer scope they will all be returned.
   * @param {string} [searchString]
   * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
   * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 25.
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ObjectApi
   */
  public userApiObjectSearchWordGet(
    clientTreeType?: IClientTreeType,
    searchString?: string,
    partitionKey?: string,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ObjectApiFp(this.configuration)
      .userApiObjectSearchWordGet(
        clientTreeType,
        searchString,
        partitionKey,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Currently Equipment and Members are supported
   * @summary Searches for the specified word. Only entire word is matched. Method does not look inside words or phrases.
   * @param {string} searchString
   * @param {string} [partitionKey] If partitionKey is known, include it. Query will be faster and cost less.
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof ObjectApi
   */
  public userApiObjectSearchWordSearchStringGet(
    searchString: string,
    partitionKey?: string,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ObjectApiFp(this.configuration)
      .userApiObjectSearchWordSearchStringGet(
        searchString,
        partitionKey,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RequestContextApi - axios parameter creator
 * @export
 */
export const RequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1RequestContextGet: async (
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestContextApi - functional programming interface
 * @export
 */
export const RequestContextApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestContextGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestContextGet(
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1RequestContextGet(
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1RequestContextGet(
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RequestContextApi - factory interface
 * @export
 */
export const RequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestContextApiFp(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestContextGet(tenantId, apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1RequestContextGet(
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiV1RequestContextGet(tenantId, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequestContextApi - object-oriented interface
 * @export
 * @class RequestContextApi
 * @extends {BaseAPI}
 */
export class RequestContextApi extends BaseAPI {
  /**
   *
   * @summary
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiRequestContextGet(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiRequestContextGet(tenantId, apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {string} [tenantId]
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiV1RequestContextGet(
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiV1RequestContextGet(tenantId, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ServiceAccessTypeApi - axios parameter creator
 * @export
 */
export const ServiceAccessTypeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: serviceaccesstype_read
     * @summary Get all ServiceAccessType
     * @param {boolean} [deleted]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypeGet: async (
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ServiceAccessType`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: serviceaccesstype_delete
     * @summary Delete ServiceAccessType
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypeIdDelete: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiServiceAccessTypeIdDelete", "id", id);
      const localVarPath = `/UserApi/ServiceAccessType/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: serviceaccesstype_read
     * @summary Get ServiceAccessType by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypeIdGet: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiServiceAccessTypeIdGet", "id", id);
      const localVarPath = `/UserApi/ServiceAccessType/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: serviceaccesstype_create
     * @summary Create or edit ServiceAccessType
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceAccessTypeDto} [iServiceAccessTypeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypeIdPut: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceAccessTypeDto?: IServiceAccessTypeDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiServiceAccessTypeIdPut", "id", id);
      const localVarPath = `/UserApi/ServiceAccessType/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iServiceAccessTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: serviceaccesstype_create
     * @summary Create ServiceAccessType
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceAccessTypeDto} [iServiceAccessTypeDto] ServiceAccessType to create. ServiceAccessType.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypePost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceAccessTypeDto?: IServiceAccessTypeDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ServiceAccessType`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iServiceAccessTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ServiceAccessTypeApi - functional programming interface
 * @export
 */
export const ServiceAccessTypeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ServiceAccessTypeApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: serviceaccesstype_read
     * @summary Get all ServiceAccessType
     * @param {boolean} [deleted]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiServiceAccessTypeGet(
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IServiceAccessTypeListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiServiceAccessTypeGet(
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: serviceaccesstype_delete
     * @summary Delete ServiceAccessType
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiServiceAccessTypeIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IServiceAccessTypeIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiServiceAccessTypeIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: serviceaccesstype_read
     * @summary Get ServiceAccessType by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiServiceAccessTypeIdGet(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IServiceAccessTypeIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiServiceAccessTypeIdGet(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: serviceaccesstype_create
     * @summary Create or edit ServiceAccessType
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceAccessTypeDto} [iServiceAccessTypeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiServiceAccessTypeIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceAccessTypeDto?: IServiceAccessTypeDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IServiceAccessTypeIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiServiceAccessTypeIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iServiceAccessTypeDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: serviceaccesstype_create
     * @summary Create ServiceAccessType
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceAccessTypeDto} [iServiceAccessTypeDto] ServiceAccessType to create. ServiceAccessType.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiServiceAccessTypePost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceAccessTypeDto?: IServiceAccessTypeDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IServiceAccessTypeIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiServiceAccessTypePost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iServiceAccessTypeDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ServiceAccessTypeApi - factory interface
 * @export
 */
export const ServiceAccessTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ServiceAccessTypeApiFp(configuration);
  return {
    /**
     * Permission: serviceaccesstype_read
     * @summary Get all ServiceAccessType
     * @param {boolean} [deleted]
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypeGet(
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IServiceAccessTypeListIRadianseResultSuccess> {
      return localVarFp
        .userApiServiceAccessTypeGet(
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: serviceaccesstype_delete
     * @summary Delete ServiceAccessType
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypeIdDelete(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IServiceAccessTypeIRadianseResultSuccess> {
      return localVarFp
        .userApiServiceAccessTypeIdDelete(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: serviceaccesstype_read
     * @summary Get ServiceAccessType by id
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypeIdGet(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IServiceAccessTypeIRadianseResultSuccess> {
      return localVarFp
        .userApiServiceAccessTypeIdGet(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: serviceaccesstype_create
     * @summary Create or edit ServiceAccessType
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceAccessTypeDto} [iServiceAccessTypeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypeIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceAccessTypeDto?: IServiceAccessTypeDto,
      options?: any
    ): AxiosPromise<IServiceAccessTypeIRadianseResultSuccess> {
      return localVarFp
        .userApiServiceAccessTypeIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iServiceAccessTypeDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: serviceaccesstype_create
     * @summary Create ServiceAccessType
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceAccessTypeDto} [iServiceAccessTypeDto] ServiceAccessType to create. ServiceAccessType.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceAccessTypePost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceAccessTypeDto?: IServiceAccessTypeDto,
      options?: any
    ): AxiosPromise<IServiceAccessTypeIRadianseResultSuccess> {
      return localVarFp
        .userApiServiceAccessTypePost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iServiceAccessTypeDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ServiceAccessTypeApi - object-oriented interface
 * @export
 * @class ServiceAccessTypeApi
 * @extends {BaseAPI}
 */
export class ServiceAccessTypeApi extends BaseAPI {
  /**
   * Permission: serviceaccesstype_read
   * @summary Get all ServiceAccessType
   * @param {boolean} [deleted]
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceAccessTypeApi
   */
  public userApiServiceAccessTypeGet(
    deleted?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ServiceAccessTypeApiFp(this.configuration)
      .userApiServiceAccessTypeGet(
        deleted,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: serviceaccesstype_delete
   * @summary Delete ServiceAccessType
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceAccessTypeApi
   */
  public userApiServiceAccessTypeIdDelete(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ServiceAccessTypeApiFp(this.configuration)
      .userApiServiceAccessTypeIdDelete(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: serviceaccesstype_read
   * @summary Get ServiceAccessType by id
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceAccessTypeApi
   */
  public userApiServiceAccessTypeIdGet(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ServiceAccessTypeApiFp(this.configuration)
      .userApiServiceAccessTypeIdGet(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: serviceaccesstype_create
   * @summary Create or edit ServiceAccessType
   * @param {string} id
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IServiceAccessTypeDto} [iServiceAccessTypeDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceAccessTypeApi
   */
  public userApiServiceAccessTypeIdPut(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iServiceAccessTypeDto?: IServiceAccessTypeDto,
    options?: AxiosRequestConfig
  ) {
    return ServiceAccessTypeApiFp(this.configuration)
      .userApiServiceAccessTypeIdPut(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iServiceAccessTypeDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: serviceaccesstype_create
   * @summary Create ServiceAccessType
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IServiceAccessTypeDto} [iServiceAccessTypeDto] ServiceAccessType to create. ServiceAccessType.Id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceAccessTypeApi
   */
  public userApiServiceAccessTypePost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iServiceAccessTypeDto?: IServiceAccessTypeDto,
    options?: AxiosRequestConfig
  ) {
    return ServiceAccessTypeApiFp(this.configuration)
      .userApiServiceAccessTypePost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iServiceAccessTypeDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ServiceListApi - axios parameter creator
 * @export
 */
export const ServiceListApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: servicelist_delete
     * @summary Delete ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceListDelete: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ServiceList`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: servicelist_read
     * @summary Get ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceListGet: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ServiceList`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: servicelist_create
     * @summary Create or edit ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceListDto} [iServiceListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceListPut: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceListDto?: IServiceListDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ServiceList`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iServiceListDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ServiceListApi - functional programming interface
 * @export
 */
export const ServiceListApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ServiceListApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: servicelist_delete
     * @summary Delete ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiServiceListDelete(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IServiceListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiServiceListDelete(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: servicelist_read
     * @summary Get ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiServiceListGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IServiceListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiServiceListGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: servicelist_create
     * @summary Create or edit ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceListDto} [iServiceListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiServiceListPut(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceListDto?: IServiceListDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IServiceListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiServiceListPut(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iServiceListDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ServiceListApi - factory interface
 * @export
 */
export const ServiceListApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ServiceListApiFp(configuration);
  return {
    /**
     * Permission: servicelist_delete
     * @summary Delete ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceListDelete(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IServiceListIRadianseResultSuccess> {
      return localVarFp
        .userApiServiceListDelete(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: servicelist_read
     * @summary Get ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceListGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IServiceListIRadianseResultSuccess> {
      return localVarFp
        .userApiServiceListGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: servicelist_create
     * @summary Create or edit ServiceList
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IServiceListDto} [iServiceListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiServiceListPut(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iServiceListDto?: IServiceListDto,
      options?: any
    ): AxiosPromise<IServiceListIRadianseResultSuccess> {
      return localVarFp
        .userApiServiceListPut(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iServiceListDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ServiceListApi - object-oriented interface
 * @export
 * @class ServiceListApi
 * @extends {BaseAPI}
 */
export class ServiceListApi extends BaseAPI {
  /**
   * Permission: servicelist_delete
   * @summary Delete ServiceList
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceListApi
   */
  public userApiServiceListDelete(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ServiceListApiFp(this.configuration)
      .userApiServiceListDelete(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: servicelist_read
   * @summary Get ServiceList
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceListApi
   */
  public userApiServiceListGet(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ServiceListApiFp(this.configuration)
      .userApiServiceListGet(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: servicelist_create
   * @summary Create or edit ServiceList
   * @param {string} [groupId] GroupId is required if using a group bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IServiceListDto} [iServiceListDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceListApi
   */
  public userApiServiceListPut(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iServiceListDto?: IServiceListDto,
    options?: AxiosRequestConfig
  ) {
    return ServiceListApiFp(this.configuration)
      .userApiServiceListPut(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iServiceListDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
